import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1024.000000 1024.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)">

<path d="M4970 9189 c-407 -278 -848 -505 -1360 -702 -351 -135 -747 -258
-1050 -327 -74 -17 -153 -35 -175 -40 -94 -23 -431 -81 -585 -100 -47 -6 -88
-14 -91 -18 -7 -8 -35 -246 -49 -412 -48 -589 -38 -1292 25 -1865 17 -152 66
-478 89 -590 7 -38 24 -121 36 -184 21 -103 24 -112 37 -95 8 10 22 29 33 41
10 12 26 33 35 47 10 14 21 23 26 20 5 -3 9 3 9 13 0 10 16 33 35 50 43 39 43
48 10 224 -133 706 -171 1494 -110 2284 18 232 24 276 39 280 6 1 61 10 121
20 399 62 841 169 1265 308 129 43 543 194 605 222 386 174 564 260 755 368
132 74 351 211 409 254 l43 32 62 -43 c321 -226 873 -510 1348 -692 125 -48
436 -160 479 -172 19 -5 105 -31 193 -56 323 -95 636 -166 991 -227 72 -12
131 -23 132 -24 4 -2 30 -272 39 -395 6 -78 10 -97 28 -111 18 -15 23 -15 41
-3 29 21 71 17 95 -8 17 -18 21 -32 17 -65 -3 -31 0 -47 13 -61 10 -10 25 -32
33 -48 16 -28 16 -27 17 61 0 154 -57 815 -72 831 -2 1 -80 15 -173 29 -514
80 -911 174 -1360 324 -673 223 -1174 463 -1728 827 -87 57 -159 104 -160 103
-1 -1 -67 -46 -147 -100z"/>
<path d="M5060 8793 c-72 -48 -313 -193 -370 -223 -25 -14 -52 -29 -60 -36 -8
-6 -61 -35 -118 -65 -57 -29 -99 -55 -93 -57 5 -2 29 6 52 17 50 25 55 26 40
7 -9 -11 -7 -15 10 -19 15 -4 19 -2 15 9 -3 8 -1 14 3 14 5 0 11 -4 13 -10 2
-6 31 -4 78 4 45 8 63 15 45 16 l-30 2 29 10 c19 7 39 7 61 1 17 -6 68 -8 111
-5 52 4 71 8 54 12 -35 9 333 1 465 -10 225 -20 433 -59 579 -110 33 -11 61
-19 62 -17 2 1 -85 47 -193 102 -240 122 -393 208 -559 314 -69 45 -129 81
-132 80 -4 0 -32 -16 -62 -36z m-427 -350 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12
5 17 0 24 -2 18 -5z"/>
<path d="M4333 8377 c-17 -7 -35 -15 -39 -20 -10 -10 58 13 71 24 11 11 8 11
-32 -4z"/>
<path d="M5128 8302 c-22 -4 -93 -72 -76 -72 7 -1 0 -8 -17 -18 l-30 -16 50
-7 c100 -14 140 -10 179 16 23 15 64 29 107 37 39 6 76 16 82 23 7 6 19 10 27
8 10 -3 8 1 -4 11 -12 10 -41 16 -70 17 -28 0 -91 2 -141 3 -49 1 -98 0 -107
-2z"/>
<path d="M5515 8229 c-106 -8 -144 -18 -205 -50 -41 -22 -57 -24 -185 -24
-100 -1 -160 -6 -210 -19 -38 -9 -83 -21 -100 -25 -25 -6 -18 -9 53 -20 45 -8
85 -17 87 -21 3 -5 -17 -16 -45 -25 -29 -10 -50 -23 -50 -31 0 -8 5 -14 11
-14 5 0 8 -4 4 -9 -3 -5 -1 -12 5 -16 5 -3 12 -28 16 -55 4 -28 10 -50 15 -50
5 0 9 -4 9 -10 0 -5 -9 -10 -19 -10 -12 0 -21 -9 -25 -24 -9 -37 -58 -80 -107
-96 -46 -14 -139 -57 -139 -64 0 -2 9 -2 20 1 11 3 20 0 20 -6 0 -6 -6 -11
-14 -11 -7 0 -19 -6 -25 -14 -16 -19 7 -27 53 -19 24 4 36 2 36 -6 0 -6 -8
-11 -17 -11 -10 -1 2 -8 27 -17 28 -9 65 -14 101 -11 37 3 55 1 53 -6 -5 -13
-109 -46 -141 -46 -15 0 -23 -6 -23 -17 0 -16 -2 -16 -11 -3 -7 11 -12 12 -15
3 -3 -7 -11 -10 -18 -7 -9 4 -16 -7 -20 -32 -4 -20 -17 -49 -28 -65 -12 -15
-22 -45 -23 -66 -3 -52 -3 -51 -25 -58 -11 -4 -20 -15 -20 -27 0 -17 5 -20 40
-16 22 2 40 0 40 -4 0 -5 -12 -8 -26 -8 -27 0 -29 -20 -3 -28 8 -3 11 -1 7 3
-12 13 64 45 109 45 50 0 57 8 54 70 -2 80 50 109 148 80 19 -5 39 -6 45 -1 6
4 27 13 46 20 38 13 100 52 100 64 0 4 -7 7 -15 7 -24 0 -115 49 -121 64 -3 8
4 33 16 55 16 33 18 45 9 62 -6 12 -8 34 -5 50 3 15 1 31 -3 34 -5 3 -7 15 -4
28 5 22 5 22 -10 2 -8 -12 -17 -34 -19 -50 -2 -17 -4 12 -3 64 0 65 -4 96 -12
98 -9 3 -9 10 -2 27 9 19 24 26 80 35 73 13 107 7 68 -13 -12 -6 -24 -17 -27
-25 -4 -11 4 -13 39 -6 24 4 60 9 79 12 62 7 148 39 200 74 14 9 41 20 60 23
19 4 82 22 140 41 58 18 137 38 175 45 39 7 80 14 93 16 12 2 22 11 22 20 0 9
-10 18 -22 22 -13 3 -56 23 -97 44 -80 41 -81 41 -246 27z m-550 -219 c-3 -5
-14 -10 -23 -9 -14 0 -13 2 3 9 27 11 27 11 20 0z m10 -30 c3 -5 1 -10 -4 -10
-6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z"/>
<path d="M6561 8091 c220 -128 432 -289 619 -469 l145 -140 218 0 c204 0 217
1 217 19 0 26 -32 40 -129 54 -73 11 -88 11 -102 -1 -23 -21 -66 -18 -79 7
-27 49 51 94 83 49 11 -16 36 -24 104 -35 50 -8 98 -18 107 -21 10 -4 26 2 39
14 77 72 183 33 194 -72 6 -51 -7 -43 138 -79 33 -9 68 -19 78 -22 15 -6 17
-1 16 46 -1 72 -15 228 -20 234 -3 2 -68 16 -145 30 -386 71 -680 143 -1049
257 -128 39 -399 131 -449 152 -61 25 -56 19 15 -23z"/>
<path d="M3505 8036 c-16 -7 -54 -19 -82 -25 -29 -7 -53 -18 -53 -24 0 -6 -2
-8 -6 -5 -3 3 -26 -1 -52 -9 -403 -124 -977 -262 -1204 -289 -32 -3 -58 -10
-58 -14 0 -4 -8 -99 -17 -211 -23 -288 -23 -1092 0 -1334 28 -282 36 -354 58
-500 20 -141 36 -198 26 -93 -5 56 7 237 19 288 6 24 7 24 15 5 7 -15 7 -11 3
12 -8 46 6 155 17 128 8 -20 8 -20 8 1 1 11 -5 26 -11 33 -11 10 -10 12 1 9
10 -2 19 20 32 77 21 95 22 108 8 100 -12 -8 -3 50 17 109 8 21 14 49 14 62 0
13 5 24 10 24 6 0 10 5 10 11 0 5 -6 7 -12 4 -7 -4 -5 0 5 8 17 14 25 43 9 33
-5 -3 -6 23 -4 57 3 34 8 63 12 65 4 1 5 14 2 29 -3 18 -1 24 7 19 8 -6 8 -1
0 18 -7 14 -15 23 -20 21 -4 -3 -11 0 -15 6 -4 8 -3 9 4 5 18 -11 14 10 -5 29
-20 21 -64 112 -98 207 -30 83 -39 216 -17 256 7 12 14 46 15 76 3 56 26 102
55 113 9 4 19 10 22 14 11 16 81 20 117 8 27 -9 32 -14 22 -21 -10 -7 -7 -8
11 -4 14 3 36 6 50 7 21 0 22 1 6 8 -14 5 -3 11 45 24 35 9 84 19 109 21 134
15 163 20 176 33 8 9 23 13 34 10 11 -3 17 0 14 7 -2 6 14 29 36 51 21 22 39
43 40 47 0 13 51 58 65 58 8 0 15 5 15 11 0 6 11 20 25 31 14 11 25 26 25 33
0 16 78 85 97 85 7 0 13 6 13 14 0 7 25 24 55 36 30 12 53 26 50 30 -2 4 10
27 28 51 18 24 32 46 32 49 0 3 11 4 23 2 13 -2 21 1 18 7 -3 5 19 17 49 27
31 9 58 21 61 25 3 5 15 9 27 9 25 1 110 38 87 39 -8 0 -28 -6 -45 -13z
m-1308 -1908 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-20 -100
c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z"/>
<path d="M5808 7993 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4770 7970 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6467 7951 c48 -30 116 -61 121 -57 4 5 -132 76 -145 76 -5 0 6 -9
24 -19z"/>
<path d="M6095 7940 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M3285 7930 c3 -5 14 -10 23 -10 15 0 15 2 2 10 -20 13 -33 13 -25 0z"/>
<path d="M6442 7900 c7 -11 17 -20 22 -20 5 0 1 9 -9 20 -10 11 -20 20 -22 20
-2 0 2 -9 9 -20z"/>
<path d="M6474 7905 c8 -8 18 -15 22 -15 3 0 1 7 -6 15 -7 8 -17 15 -22 15 -5
0 -3 -7 6 -15z"/>
<path d="M6510 7870 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6721 7877 c2 -1 13 -9 24 -17 19 -14 19 -14 6 3 -7 9 -18 17 -24 17
-6 0 -8 -1 -6 -3z"/>
<path d="M6650 7860 c0 -5 6 -10 14 -10 8 0 18 5 21 10 3 6 -3 10 -14 10 -12
0 -21 -4 -21 -10z"/>
<path d="M6607 7815 c10 -13 23 -24 28 -23 23 1 35 -3 35 -13 0 -6 7 -17 15
-25 34 -34 6 -94 -30 -64 -8 7 -15 9 -15 4 0 -5 -8 0 -16 11 -11 14 -18 16
-21 8 -5 -15 -33 -18 -33 -3 0 5 -15 16 -33 25 -22 10 -38 28 -47 50 -12 31
-18 35 -49 35 -20 0 -47 3 -61 6 -22 5 -23 4 -7 -6 10 -7 22 -21 26 -33 5 -14
33 -31 81 -51 40 -17 75 -35 77 -41 1 -5 -14 -10 -35 -10 -20 -1 -46 -5 -57
-9 -27 -12 -55 -14 -55 -5 0 4 6 10 13 12 6 3 2 6 -10 6 -14 1 -23 7 -23 17 0
16 8 16 75 -2 l20 -6 -20 15 c-11 7 -35 19 -52 25 -27 9 -33 8 -33 -4 0 -7 -7
-14 -15 -14 -8 0 -15 7 -15 16 0 12 -6 15 -22 10 -13 -3 -31 -6 -42 -6 -14 0
-16 -3 -7 -13 7 -9 7 -17 0 -24 -14 -14 -1 -41 30 -58 19 -10 21 -14 9 -15
-21 0 -24 -16 -5 -24 6 -3 -1 -4 -18 -1 l-30 4 30 -14 30 -14 -30 -1 c-17 0
-48 9 -69 21 -21 11 -48 19 -60 17 -16 -3 -6 -10 38 -31 32 -15 68 -28 80 -28
15 -1 13 -3 -9 -9 l-30 -7 28 -11 c33 -14 40 -58 7 -47 -12 4 -20 2 -20 -6 0
-19 -26 7 -55 57 -24 41 -93 100 -104 89 -3 -3 16 -27 42 -53 33 -33 44 -51
38 -61 -5 -8 -16 -11 -25 -8 -9 4 -23 -3 -34 -18 -22 -28 -46 -135 -37 -168 4
-16 1 -14 -11 7 -14 24 -15 36 -5 61 15 42 14 55 -4 55 -9 0 -15 9 -15 21 0
14 -5 19 -14 16 -8 -3 -20 1 -26 9 -15 16 -30 19 -30 3 0 -5 5 -7 10 -4 6 3
10 1 10 -4 0 -6 -11 -11 -25 -11 -16 0 -25 -6 -25 -16 0 -12 -7 -15 -25 -12
-14 3 -25 2 -25 -1 0 -4 -9 -7 -19 -7 -19 0 -19 1 0 27 11 15 15 30 10 33 -5
3 -12 -2 -15 -11 -6 -14 -9 -15 -15 -4 -9 14 -31 7 -31 -10 0 -6 5 -7 10 -4
20 12 9 -13 -17 -39 -20 -20 -28 -24 -35 -14 -8 14 -12 4 -8 -26 1 -11 -3 -15
-9 -12 -6 4 -11 3 -11 -2 0 -6 -11 -9 -25 -8 -28 1 -31 6 -13 24 8 8 8 15 -2
27 -16 20 -51 20 -44 1 3 -8 12 -12 20 -9 8 3 14 1 14 -5 0 -6 -6 -12 -12 -15
-10 -3 -10 -9 0 -26 10 -17 10 -21 -1 -21 -22 0 -47 -34 -47 -64 0 -27 -2 -28
-34 -22 -19 4 -37 2 -40 -3 -6 -9 23 -38 33 -33 3 2 7 -1 9 -7 5 -15 -4 -14
-37 4 -24 12 -42 35 -42 55 0 3 -7 13 -16 22 -14 16 -11 16 39 11 44 -4 56 -2
71 14 17 19 17 21 -3 44 -11 14 -18 17 -14 8 4 -12 -1 -16 -20 -16 -15 0 -26
6 -29 18 -6 21 -42 26 -51 7 -3 -7 -4 -4 -3 7 1 15 -5 21 -26 23 -16 2 -37 12
-48 23 -15 15 -24 17 -39 9 -17 -9 -22 -7 -30 12 -5 13 -9 17 -9 11 -1 -7 -7
-13 -15 -13 -8 0 -17 6 -20 13 -5 10 -7 10 -12 0 -3 -7 -12 -13 -20 -13 -8 0
-14 -7 -14 -15 0 -9 -10 -19 -23 -24 -13 -5 -29 -16 -36 -25 -9 -11 -21 -14
-35 -10 -17 5 -18 4 -9 -6 9 -10 8 -16 -4 -28 -13 -13 -16 -13 -24 -1 -7 10
-8 7 -7 -11 2 -15 -2 -24 -9 -23 -7 2 -16 -9 -19 -24 -8 -31 -41 -66 -54 -58
-5 3 -22 -13 -37 -35 -22 -34 -25 -45 -15 -60 10 -16 7 -20 -18 -32 -17 -7
-30 -16 -30 -21 0 -4 -9 -3 -20 3 -17 9 -20 8 -20 -10 0 -11 -5 -19 -12 -18
-7 2 -12 -4 -13 -12 -1 -25 -27 -70 -37 -64 -15 9 -48 -7 -48 -23 0 -18 28
-42 49 -43 8 0 29 11 47 25 18 14 36 25 41 25 8 0 35 -72 53 -140 5 -19 17
-40 27 -48 16 -11 18 -11 21 6 2 13 14 22 33 26 32 6 49 36 49 88 0 21 9 38
30 56 37 32 38 47 4 69 -39 25 -29 82 25 137 23 23 41 49 41 58 0 24 28 48 56
48 34 0 43 -29 16 -51 -12 -9 -22 -20 -22 -24 0 -4 -10 -15 -22 -25 -19 -15
-22 -28 -23 -88 l0 -71 30 -5 c17 -3 52 1 79 9 52 16 116 20 116 8 0 -15 -62
-43 -95 -43 -42 0 -67 -9 -59 -22 3 -5 -3 -12 -15 -15 -22 -6 -27 -18 -12 -28
5 -3 12 -1 16 5 10 17 34 11 46 -11 9 -17 8 -25 -6 -38 -15 -15 -17 -15 -29 2
-31 41 -56 7 -56 -77 0 -24 -7 -35 -30 -48 -17 -10 -29 -22 -28 -29 2 -6 -3
-14 -10 -16 -9 -4 -11 2 -6 21 6 24 4 26 -25 26 -17 0 -31 -4 -31 -10 0 -5 -7
-7 -15 -4 -8 4 -15 1 -15 -6 0 -9 -12 -11 -38 -8 -31 5 -38 2 -39 -12 -1 -10
7 -21 16 -26 13 -6 16 -15 12 -28 -7 -17 -8 -17 -24 -2 -15 15 -17 16 -17 2 0
-19 -11 -21 -28 -4 -7 7 -12 9 -12 4 0 -11 27 -36 39 -36 6 0 11 6 11 13 0 8
4 7 10 -3 5 -8 10 -10 10 -5 0 6 4 3 10 -5 5 -8 19 -15 32 -15 13 -1 30 -5 37
-9 10 -6 11 -3 6 13 -8 26 9 28 25 4 8 -12 10 -13 7 -3 -2 8 -13 19 -25 25
-25 11 -31 30 -6 21 8 -3 13 -2 10 3 -7 10 17 21 44 21 9 0 24 9 31 21 12 17
18 19 42 10 16 -6 49 -11 73 -11 29 0 43 -4 39 -10 -4 -6 -15 -8 -26 -5 -13 4
-19 2 -19 -9 0 -9 -5 -16 -12 -16 -6 0 -3 -9 8 -21 16 -17 16 -22 4 -29 -11
-7 -4 -10 23 -10 23 0 36 -4 32 -10 -4 -7 7 -8 34 -4 39 6 40 6 35 -20 -4 -22
-1 -26 20 -26 14 0 31 9 39 21 12 16 21 19 50 14 21 -4 38 -15 44 -27 5 -11
34 -31 68 -44 66 -27 83 -30 63 -11 -18 17 -65 37 -88 37 -13 0 -22 9 -26 28
-4 15 -11 32 -16 38 -5 8 -3 18 7 28 19 19 29 20 54 4 22 -13 50 7 44 32 -2 8
8 28 22 44 14 16 25 33 25 39 0 5 7 7 15 3 11 -4 15 2 16 22 l0 27 11 -25 c5
-14 13 -45 16 -70 6 -40 10 -45 36 -48 16 -2 26 0 22 6 -3 6 -2 21 3 33 l8 24
8 -25 c7 -24 8 -24 15 -5 7 18 9 17 20 -10 9 -21 14 -26 18 -15 8 22 24 30 50
23 18 -4 24 -1 29 16 3 11 9 21 14 21 12 0 11 -13 0 -25 -11 -12 -51 -83 -51
-92 0 -3 6 0 13 6 8 6 17 8 20 4 7 -6 11 11 8 35 -1 6 2 12 7 12 8 0 20 26 20
46 1 3 10 14 22 24 12 11 19 24 15 29 -3 7 0 8 9 5 16 -6 10 -32 -20 -81 -16
-25 -14 -25 14 5 18 18 32 37 32 41 0 4 11 20 24 36 16 19 25 23 28 14 4 -11
10 -11 32 -1 21 9 26 17 21 32 -4 11 -3 20 2 21 4 0 25 3 47 5 32 4 37 2 32
-11 -3 -10 1 -18 11 -22 9 -4 25 -15 35 -25 30 -30 36 -21 32 45 -3 44 -2 56
5 42 9 -19 10 -19 10 3 1 12 -3 22 -9 22 -5 0 -10 7 -10 16 0 14 3 14 15 4 10
-8 15 -9 15 -1 0 6 18 14 41 17 24 4 43 14 47 23 3 9 14 25 24 35 10 11 18 23
18 28 0 11 34 10 46 -1 15 -15 64 -1 62 18 -3 44 2 50 55 61 46 9 59 8 95 -8
23 -10 39 -22 35 -25 -3 -4 7 -8 23 -9 16 0 34 -2 39 -3 6 -2 19 -3 30 -4 15
-1 16 -4 7 -10 -14 -8 -7 -61 8 -61 4 0 7 -7 6 -16 0 -11 12 -21 33 -29 34
-11 42 -20 57 -60 6 -18 8 -18 11 -3 4 16 7 17 34 3 16 -9 29 -20 29 -25 0
-11 -48 -25 -57 -16 -4 3 1 6 11 6 10 0 14 5 11 11 -5 7 -14 4 -27 -8 -11 -10
-30 -17 -42 -15 -21 3 -21 3 2 -13 15 -11 27 -14 35 -7 7 5 21 6 32 2 11 -4
29 -4 41 0 11 5 27 4 34 0 11 -7 8 -13 -13 -30 -15 -12 -27 -31 -27 -42 0 -12
-10 -40 -22 -64 -12 -24 -19 -46 -16 -49 3 -3 29 6 58 21 50 25 151 47 121 26
-11 -8 -11 -10 0 -15 10 -3 4 -14 -20 -37 -18 -17 -31 -24 -28 -16 4 10 1 13
-9 9 -7 -3 -14 0 -14 6 0 13 30 29 48 25 7 -1 8 0 2 3 -5 2 -8 8 -5 13 11 18
-37 -4 -53 -24 -26 -32 -116 -90 -120 -77 -5 16 -39 13 -46 -4 -4 -12 3 -15
35 -15 43 0 112 27 104 40 -3 4 2 13 9 19 9 8 17 8 20 2 3 -5 0 -12 -6 -14 -8
-4 -7 -6 4 -6 15 -1 15 -4 4 -27 -8 -14 -22 -31 -32 -39 -15 -11 -16 -15 -4
-15 27 -1 -21 -30 -49 -30 -26 1 -26 1 4 14 l30 12 -25 8 c-24 7 -24 8 -5 15
11 5 23 7 28 4 4 -2 7 0 7 6 0 6 -15 7 -37 4 -21 -4 -47 -7 -58 -7 -20 -1 -32
-8 -66 -39 -16 -15 -19 -27 -15 -63 4 -36 2 -44 -12 -44 -15 0 -15 -2 -2 -10
11 -6 22 -3 40 13 24 21 65 47 74 47 15 0 -8 -49 -33 -70 -17 -14 -43 -35 -58
-48 -19 -16 -24 -25 -15 -29 8 -3 10 -9 4 -16 -5 -7 -12 -25 -16 -40 -9 -38
13 -32 34 9 9 17 25 30 38 31 18 2 22 -2 23 -30 1 -17 1 -38 0 -46 -4 -26 18
0 30 36 6 21 21 45 32 54 l21 16 -23 12 c-18 10 -20 15 -10 27 6 8 16 14 21
14 11 0 38 25 38 36 0 4 12 17 26 30 14 13 23 28 19 33 -3 5 -1 12 4 15 4 3
11 19 14 34 4 19 14 32 29 37 20 6 21 8 5 12 -11 3 -16 10 -13 20 3 8 6 17 6
19 0 2 9 4 20 4 11 0 20 5 20 10 0 6 15 10 34 10 19 0 41 3 50 6 28 11 17 24
-21 24 -36 0 -36 0 -15 18 17 15 19 21 9 31 -9 10 -6 18 16 37 15 13 34 24 41
24 7 0 21 9 31 20 17 19 16 19 -21 13 -22 -3 -55 -16 -75 -29 -19 -13 -43 -24
-53 -24 -10 0 -14 -5 -10 -11 4 -6 -1 -9 -12 -8 -11 2 -23 1 -29 -3 -15 -9
-85 -14 -85 -5 0 4 0 12 0 18 0 7 9 9 21 6 12 -3 18 -3 15 0 -3 4 -2 11 3 17
5 6 9 36 8 66 -2 54 -2 55 -31 52 -28 -3 -50 14 -40 30 7 12 92 10 99 -2 3 -5
15 -10 26 -10 10 0 19 -6 19 -12 0 -10 3 -9 9 1 6 9 28 13 66 12 44 0 56 3 52
14 -4 9 6 15 34 20 25 4 39 12 39 22 0 10 -6 13 -16 9 -39 -15 -64 -18 -64 -7
0 20 -20 11 -32 -14 -6 -14 -18 -25 -25 -25 -8 0 -29 11 -47 25 -18 14 -46 25
-62 25 -22 0 -26 3 -14 10 12 8 11 10 -7 10 -14 0 -23 6 -23 15 0 8 -9 23 -20
32 -11 10 -20 22 -20 28 0 5 5 3 10 -5 8 -13 11 -12 16 7 7 25 56 42 63 22 5
-17 71 -79 82 -79 5 0 9 -7 9 -15 0 -21 64 -20 84 1 24 23 1 95 -25 79 -9 -6
-29 42 -29 68 l0 22 18 -23 18 -23 11 23 c8 18 7 32 -4 59 -17 40 -74 133 -85
137 -5 2 -8 12 -8 23 0 10 -12 25 -27 33 -16 8 -25 15 -20 16 4 0 0 11 -9 25
-16 24 -16 25 2 18 11 -3 29 -13 42 -21 14 -9 22 -10 22 -3 0 6 -9 16 -20 23
-21 14 -29 34 -7 22 6 -4 -9 14 -35 42 -26 27 -58 63 -72 79 -13 17 -28 27
-32 22 -4 -4 7 -25 24 -46 18 -22 32 -42 32 -44 0 -10 -51 3 -65 16 -21 22
-19 30 6 16 21 -11 21 -11 3 20 -17 29 -17 31 2 52 10 12 13 19 7 15 -7 -4
-13 -3 -13 1 0 5 -9 9 -19 9 -16 0 -18 -3 -8 -15 9 -11 9 -15 -1 -19 -7 -2
-19 -11 -28 -19 -14 -14 -18 -13 -45 13 -16 15 -25 30 -20 34 13 8 -84 129
-139 173 -47 38 -47 38 -43 14 3 -14 16 -27 33 -34 15 -6 33 -20 39 -31 9 -18
8 -19 -11 -15 -11 4 -23 14 -25 25 -4 13 -15 18 -39 18 -19 0 -34 5 -34 11 0
8 -4 8 -14 0 -11 -9 -17 -8 -28 7 -16 23 -62 47 -106 55 l-33 7 18 -25z m-282
-124 c10 -17 -12 -21 -25 -6 -10 12 -10 15 3 15 9 0 18 -4 22 -9z m69 -50 c-6
-6 -11 1 -18 29 l-7 25 15 -25 c8 -14 12 -27 10 -29z m178 11 c12 -12 -81 -3
-102 10 -10 6 4 7 39 4 30 -3 58 -9 63 -14z m243 8 c3 -5 -1 -10 -9 -10 -9 0
-16 5 -16 10 0 6 4 10 9 10 6 0 13 -4 16 -10z m131 -57 c-10 -10 -19 5 -10 18
6 11 8 11 12 0 2 -7 1 -15 -2 -18z m-591 -1 c-3 -3 -11 0 -18 7 -9 10 -8 11 6
5 10 -3 15 -9 12 -12z m-20 -43 c11 -17 -1 -21 -15 -4 -8 9 -8 15 -2 15 6 0
14 -5 17 -11z m-95 -90 c0 -5 -13 -9 -30 -9 -16 0 -30 4 -30 8 0 5 14 9 30 10
17 0 30 -4 30 -9z m-255 -28 c3 -5 1 -12 -4 -15 -5 -3 -11 1 -15 9 -6 16 9 21
19 6z m1199 -47 c23 -23 19 -40 -4 -19 -11 10 -20 22 -20 27 0 12 7 10 24 -8z
m-244 -194 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4
10 -10z m68 -28 c13 -9 6 -42 -9 -42 -11 0 -12 17 -1 23 4 2 2 2 -5 1 -14 -4
-25 10 -16 20 8 8 15 7 31 -2z m179 -18 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6
11 1 17 -2 13 -5z m-93 -66 c-3 -13 -10 -30 -15 -38 -7 -13 -8 -13 -9 0 0 27
12 60 22 60 5 0 6 -10 2 -22z m-168 -4 c19 -9 34 -21 34 -26 0 -7 -5 -6 -13 0
-7 7 -29 18 -48 26 -19 9 -28 15 -21 16 8 0 29 -7 48 -16z m334 0 c0 -8 -4
-12 -10 -9 -5 3 -10 10 -10 16 0 5 5 9 10 9 6 0 10 -7 10 -16z m-1730 -24 c13
-9 13 -11 1 -19 -18 -12 -41 -3 -41 15 0 16 18 18 40 4z m1096 -17 c-10 -10
-19 5 -10 18 6 11 8 11 12 0 2 -7 1 -15 -2 -18z m-26 -7 c0 -3 -4 -8 -10 -11
-5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m525 -67 c-7 -10 -35 -1
-35 11 0 5 9 6 20 3 11 -3 17 -9 15 -14z m-23 -31 c-7 -7 -12 -8 -12 -2 0 14
12 26 19 19 2 -3 -1 -11 -7 -17z m-1042 2 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4
10 3 6 8 10 11 10 2 0 4 -4 4 -10z m1085 0 c3 -5 -1 -10 -9 -10 -9 0 -16 5
-16 10 0 6 4 10 9 10 6 0 13 -4 16 -10z m-920 -20 c3 -5 1 -10 -4 -10 -6 0
-11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-96 -30 c9 -14 11 -21 4 -16 -9
5 -13 0 -13 -13 0 -12 -4 -21 -9 -21 -6 0 -9 12 -8 28 1 17 -3 26 -10 25 -7
-2 -13 4 -13 13 0 23 30 13 49 -16z m1121 0 c18 -12 2 -12 -25 0 -13 6 -15 9
-5 9 8 0 22 -4 30 -9z m-1224 -9 c-8 -12 21 -34 34 -26 5 3 10 1 10 -4 0 -16
-21 -13 -42 6 -20 18 -24 33 -7 33 5 0 8 -4 5 -9z m-76 -11 c0 -5 7 -10 15
-10 8 0 15 -4 15 -10 0 -6 -10 -5 -25 2 -25 11 -34 28 -15 28 6 0 10 -4 10
-10z m220 3 c0 -5 -5 -15 -10 -23 -7 -12 -9 -10 -7 8 1 19 17 33 17 15z m40
-23 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z
m-907 -25 c-5 -13 -23 -22 -23 -11 0 15 14 35 21 31 4 -3 6 -12 2 -20z m851
-4 c3 -5 -10 -11 -29 -13 -24 -3 -35 0 -35 9 0 15 56 18 64 4z m-167 -16 c0
-18 -16 -19 -37 -4 -13 9 -12 10 2 5 10 -3 20 -1 23 4 9 14 12 12 12 -5z
m-652 -5 c4 -6 11 -8 16 -5 5 3 6 0 3 -8 -5 -14 -64 -20 -64 -5 0 4 7 8 16 8
8 0 12 5 9 10 -3 6 -2 10 4 10 5 0 13 -5 16 -10z m126 -64 c-1 -4 3 -14 10
-22 9 -11 7 -15 -6 -20 -24 -9 -31 8 -26 58 3 40 4 41 14 18 6 -14 9 -29 8
-34z m-177 28 c5 -14 4 -15 -9 -4 -17 14 -19 20 -6 20 5 0 12 -7 15 -16z m54
-13 c10 -6 10 -11 -3 -21 -14 -12 -18 -11 -25 0 -15 24 2 38 28 21z m264 -9
c4 -14 -1 -17 -21 -16 -44 2 -47 5 -16 19 17 8 31 14 31 15 1 0 4 -8 6 -18z
m246 6 c-7 -19 -38 -22 -38 -4 0 10 9 16 21 16 12 0 19 -5 17 -12z m112 -9 c0
-5 -10 -9 -21 -9 -18 0 -19 2 -9 15 12 15 30 12 30 -6z m83 1 c3 -11 1 -20 -4
-20 -5 0 -9 9 -9 20 0 11 2 20 4 20 2 0 6 -9 9 -20z m-513 0 c0 -5 -2 -10 -4
-10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m-245 -10 c8 -13 -5
-13 -25 0 -13 8 -13 10 2 10 9 0 20 -4 23 -10z m175 -63 c22 -9 23 -11 6 -15
-10 -2 -22 1 -26 8 -4 6 -15 10 -25 8 -10 -2 -20 3 -23 11 -5 14 13 11 68 -12z
m74 11 c5 -10 7 -10 12 0 3 6 10 12 16 12 7 0 7 -5 -1 -13 -6 -8 -8 -17 -4
-20 3 -4 1 -7 -6 -7 -13 0 -41 24 -41 34 0 11 18 6 24 -6z m120 -30 c6 -4 7
-10 3 -14 -4 -4 -12 -3 -18 3 -6 6 -18 9 -25 6 -8 -3 -14 1 -14 10 0 18 33 28
39 12 2 -5 9 -13 15 -17z m-64 2 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6
-1 10 4 10 6 0 11 -4 11 -10z m-238 -16 c-22 -17 -29 -17 -35 -1 -4 10 4 14
24 14 25 0 26 -2 11 -13z m-262 -20 c0 -8 -4 -12 -10 -9 -5 3 -10 13 -10 21 0
8 5 12 10 9 6 -3 10 -13 10 -21z m2019 -192 c-6 -10 -20 -18 -30 -18 -26 0
-24 11 4 24 32 16 39 14 26 -6z m-38 -90 c-10 -19 -71 -37 -71 -20 0 8 16 12
33 9 5 -1 5 3 2 9 -9 14 27 42 38 30 5 -4 4 -17 -2 -28z m-81 -42 c0 -5 -5
-10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m97 -16 c-3 -3
-12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M5750 7770 c-6 -11 -9 -40 -7 -63 l4 -42 1 46 c1 25 7 50 14 57 6 6
9 14 6 18 -4 3 -11 -4 -18 -16z"/>
<path d="M4046 7763 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M6236 7761 c-4 -5 1 -8 9 -7 21 3 31 16 12 16 -9 0 -18 -4 -21 -9z"/>
<path d="M3693 7718 c-23 -30 -24 -41 -2 -21 12 12 20 25 17 28 -3 3 -10 0
-15 -7z"/>
<path d="M4560 7720 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M4445 7695 l-30 -14 33 -1 c22 0 32 5 32 15 0 8 -1 15 -2 14 -2 0
-16 -7 -33 -14z"/>
<path d="M5691 7684 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4500 7674 l-25 -15 25 7 c28 7 35 12 29 18 -2 2 -15 -2 -29 -10z"/>
<path d="M3576 7655 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M6076 7647 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M4375 7620 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M4305 7600 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M7010 7599 c0 -5 9 -9 20 -9 11 0 20 2 20 4 0 2 -9 6 -20 9 -11 3
-20 1 -20 -4z"/>
<path d="M5735 7580 c-7 -11 35 -30 68 -30 19 0 17 3 -11 20 -37 22 -48 24
-57 10z"/>
<path d="M4370 7570 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6060 7550 c0 -5 9 -10 20 -10 11 0 23 -7 26 -15 4 -8 10 -15 15 -15
5 0 2 11 -7 25 -16 24 -54 35 -54 15z"/>
<path d="M5947 7506 c-4 -10 -1 -13 9 -9 15 6 19 23 5 23 -5 0 -11 -7 -14 -14z"/>
<path d="M4065 7493 c-34 -8 -38 -20 -5 -15 16 2 30 8 30 13 0 5 -1 8 -2 8 -2
-1 -12 -3 -23 -6z"/>
<path d="M5750 7471 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M5210 7460 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M5145 7438 c-11 -6 -33 -24 -49 -39 l-28 -29 30 0 c35 0 55 20 45 45
-4 12 -3 16 4 12 15 -9 44 3 37 14 -7 12 -14 11 -39 -3z m-22 -43 c-3 -9 -8
-14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z"/>
<path d="M5800 7439 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M7371 7424 c49 -56 177 -230 251 -344 82 -126 148 -245 213 -387 l42
-93 30 43 c51 70 81 140 80 181 -1 31 4 42 26 58 16 11 31 36 38 61 10 39 9
42 -17 61 -15 12 -77 48 -138 81 -97 52 -155 80 -256 124 -24 10 -24 10 4 4
71 -15 301 -128 398 -195 9 -7 21 -9 25 -4 4 4 8 54 8 110 0 98 -2 106 -35
171 -19 38 -47 77 -61 88 -24 17 -31 18 -64 7 -48 -16 -101 -5 -134 28 l-26
26 -205 4 -205 4 26 -28z"/>
<path d="M3359 7394 c-24 -26 -29 -35 -16 -32 10 1 27 18 38 36 27 41 21 41
-22 -4z"/>
<path d="M3616 7386 l7 -29 -22 22 c-18 18 -29 21 -54 15 -46 -9 -67 -22 -61
-38 3 -7 -2 -16 -10 -19 -9 -4 -16 -14 -16 -24 0 -10 -7 -31 -15 -46 -8 -15
-12 -34 -9 -42 6 -16 -9 -48 -37 -76 -10 -10 -19 -27 -19 -36 0 -10 -9 -29
-20 -43 -11 -14 -20 -38 -20 -53 0 -15 -9 -45 -20 -67 -25 -49 -25 -53 -1 -45
31 10 41 -21 23 -74 -8 -25 -18 -50 -22 -54 -4 -4 -37 -8 -73 -9 -71 -1 -127
-25 -127 -53 0 -19 -69 -50 -82 -37 -5 5 -10 38 -11 75 -1 36 -5 68 -9 72 -3
4 -55 8 -113 10 -81 3 -115 0 -136 -10 -16 -9 -47 -16 -69 -17 -41 -1 -87 -29
-76 -46 3 -6 -2 -9 -12 -8 -10 0 -16 -6 -16 -16 1 -10 -2 -15 -7 -12 -5 3 -9
-1 -9 -9 0 -7 -13 -23 -29 -35 -18 -13 -38 -45 -55 -88 l-26 -68 19 -32 c14
-23 16 -34 8 -38 -7 -2 2 -5 18 -6 26 -1 27 -3 10 -10 -16 -7 -14 -9 15 -9 23
-1 30 2 21 8 -20 13 3 23 31 12 12 -6 19 -10 14 -10 -5 -1 5 -15 23 -31 17
-17 31 -35 31 -41 0 -5 4 -8 9 -5 4 3 6 -6 3 -21 -3 -17 -1 -24 6 -19 6 3 12
2 14 -3 4 -12 155 -99 268 -156 l85 -42 33 20 c28 16 38 18 58 8 14 -6 29 -9
34 -6 15 9 23 -17 9 -27 -10 -7 -8 -8 8 -3 12 3 24 1 28 -5 3 -5 2 -10 -3 -10
-23 0 -18 -31 10 -69 29 -40 30 -45 29 -144 -1 -70 3 -108 11 -118 7 -9 42
-36 78 -61 36 -25 95 -66 131 -91 77 -53 248 -157 259 -157 5 0 10 3 12 8 2 4
20 16 42 27 21 10 55 40 74 65 20 25 47 55 60 68 35 33 9 27 -28 -8 -18 -16
-37 -30 -44 -30 -6 1 7 16 28 35 32 28 48 35 82 35 24 0 46 5 50 12 4 7 3 8
-4 4 -7 -4 -20 -3 -29 3 -16 9 -14 11 15 21 17 7 32 17 32 24 0 17 58 70 98
90 34 18 40 31 18 39 -10 4 -12 16 -6 46 7 39 6 40 -16 35 -15 -4 -24 -2 -24
5 0 6 5 11 10 11 6 0 5 6 -2 14 -7 8 -17 11 -22 8 -5 -3 -6 0 -2 6 4 7 17 12
29 13 12 0 16 3 9 6 -6 2 -9 9 -6 14 3 6 -2 21 -10 34 -9 14 -13 25 -9 25 8 0
45 90 50 123 9 54 11 63 12 74 2 20 53 41 81 32 14 -4 45 -7 71 -8 25 -1 50
-6 57 -13 9 -9 17 -8 37 2 14 7 25 18 25 23 0 22 -94 139 -135 167 -24 16 -46
30 -50 30 -4 0 -13 6 -20 13 -44 38 -49 41 -53 29 -7 -22 -19 -13 -26 19 -3
19 0 42 10 60 15 30 15 30 -7 27 -17 -2 -24 3 -29 22 -16 62 45 150 104 150
49 1 98 32 102 64 2 21 -1 26 -12 22 -8 -3 -21 -3 -29 0 -12 5 -13 10 -4 20
18 22 -3 16 -30 -9 -25 -22 -109 -59 -163 -71 -14 -3 -33 -8 -41 -12 -25 -9
-30 27 -8 57 23 31 21 34 -32 44 -20 4 -37 13 -37 19 0 6 28 25 63 41 34 16
85 47 112 67 28 21 60 38 73 38 13 0 20 4 17 10 -3 6 -19 10 -36 10 -16 0 -29
5 -29 12 0 7 -6 5 -17 -4 -10 -9 -36 -19 -58 -23 -22 -4 -49 -12 -60 -18 -11
-6 -29 -11 -39 -11 -11 -1 -20 -9 -22 -19 -3 -23 -3 -23 -36 -31 -17 -4 -28
-2 -28 4 0 5 7 10 15 10 8 0 15 9 15 19 0 18 -3 18 -44 6 -24 -8 -48 -10 -52
-7 -4 4 -4 -1 -1 -10 4 -10 2 -18 -3 -18 -4 0 -22 -11 -38 -25 -16 -13 -32
-22 -36 -18 -3 3 -6 -1 -6 -10 0 -9 -5 -17 -12 -17 -6 0 -19 -7 -28 -15 -21
-19 -75 -3 -77 23 -1 9 -5 31 -8 47 -5 26 -5 27 6 11 15 -24 31 -2 19 29 -6
16 -4 21 11 21 10 0 19 -5 19 -11 0 -14 20 17 20 32 0 7 -7 10 -15 7 -8 -4
-15 -1 -15 6 0 8 9 10 25 6 14 -4 25 -2 25 3 0 5 11 12 25 15 14 4 22 11 19
19 -3 8 6 18 21 25 25 11 36 52 14 52 -5 0 -8 4 -5 9 4 5 -6 8 -20 6 -19 -2
-28 3 -31 16 -4 15 -9 17 -19 9 -7 -6 -38 -14 -70 -17 -57 -6 -57 -6 -50 18
20 66 27 122 16 133 -9 8 -10 4 -4 -18z m-255 -429 c-16 -16 -26 0 -10 19 9
11 15 12 17 4 2 -6 -1 -17 -7 -23z m883 -70 c-11 -6 -29 -21 -42 -35 -16 -17
-39 -26 -77 -31 -30 -4 -52 -4 -49 1 3 4 12 8 20 8 14 0 54 19 64 31 3 3 22
12 43 18 20 7 37 17 37 22 0 6 5 7 11 3 8 -4 5 -10 -7 -17z m-536 -55 c6 -18
-15 -14 -22 4 -4 10 -1 14 6 12 6 -2 14 -10 16 -16z m-108 -342 c0 -5 -4 -10
-9 -10 -6 0 -13 5 -16 10 -3 6 1 10 9 10 9 0 16 -4 16 -10z m-73 -70 c-3 -10
-1 -20 3 -22 13 -5 16 -61 3 -65 -6 -2 -13 4 -15 13 -3 16 -4 16 -17 1 -12
-15 -11 -17 3 -17 13 0 15 -4 6 -19 -5 -11 -15 -32 -20 -47 -9 -23 -9 -25 4
-15 12 10 15 9 19 -6 4 -17 4 -17 12 1 5 11 4 21 -3 25 -17 10 -2 51 18 51 10
0 23 -7 31 -16 11 -13 10 -21 -4 -47 -9 -18 -18 -50 -20 -72 l-4 -39 -47 1
c-87 2 -88 2 -82 18 4 11 -2 15 -24 15 -20 0 -30 5 -30 15 0 24 -28 6 -42 -27
-11 -25 -17 -28 -40 -24 -21 4 -28 1 -28 -9 0 -22 -17 -18 -34 7 -15 21 -14
23 27 41 23 11 46 26 50 33 4 8 17 14 27 14 14 0 20 7 20 24 0 14 7 32 16 40
8 9 13 16 10 16 -3 0 4 11 16 25 12 14 37 28 55 31 23 4 33 11 29 20 -3 9 1
14 12 14 9 0 23 9 30 20 16 26 26 26 19 0z m575 -175 c3 -14 -1 -30 -8 -36
-11 -9 -14 -7 -14 9 0 11 -3 27 -6 36 -4 10 -1 16 9 16 8 0 17 -11 19 -25z
m-738 -84 c4 -5 -3 -7 -14 -4 -23 6 -26 13 -6 13 8 0 17 -4 20 -9z m216 -30
c0 -9 -24 -21 -41 -21 -16 0 -10 18 9 23 28 8 32 7 32 -2z m0 -35 c0 -2 -7 -6
-15 -10 -8 -3 -15 -1 -15 4 0 6 7 10 15 10 8 0 15 -2 15 -4z m-220 -76 c0 -5
-7 -7 -15 -4 -8 4 -15 8 -15 10 0 2 7 4 15 4 8 0 15 -4 15 -10z m570 -25 c0
-2 -10 -10 -22 -16 -21 -11 -22 -11 -9 4 13 16 31 23 31 12z m-510 -95 c0 -11
-4 -20 -10 -20 -5 0 -10 9 -10 20 0 11 5 20 10 20 6 0 10 -9 10 -20z m374 -85
c-7 -16 -24 -21 -24 -6 0 8 7 13 27 20 1 1 0 -6 -3 -14z m-424 -29 c0 -3 -4
-8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m357 -184 c14
11 15 11 11 -2 -7 -22 -33 -18 -34 5 -1 16 0 17 3 2 4 -15 7 -16 20 -5z m43
-18 c0 -8 -4 -12 -10 -9 -5 3 -10 10 -10 16 0 5 5 9 10 9 6 0 10 -7 10 -16z
m40 -14 c-24 -15 -37 -11 -16 5 11 8 22 12 25 9 3 -3 -1 -9 -9 -14z"/>
<path d="M3445 6210 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M3498 6213 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3460 6180 c0 -5 1 -10 3 -10 1 0 16 -4 33 -9 29 -8 31 -7 26 11 -4
15 -7 17 -14 6 -7 -10 -11 -10 -15 0 -6 14 -33 16 -33 2z"/>
<path d="M5195 7400 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z"/>
<path d="M8043 7381 c70 -130 72 -140 71 -280 l0 -134 44 -40 c24 -23 48 -50
54 -61 8 -15 1 -13 -23 10 -77 70 -83 74 -93 64 -6 -6 -11 -38 -12 -71 -1 -41
-6 -65 -15 -70 -36 -21 -29 -12 -131 -194 l-39 -69 16 -46 c31 -86 112 -375
119 -422 4 -27 9 -48 12 -48 3 0 17 11 32 25 42 39 54 33 26 -11 l-17 -25 27
12 c41 19 43 2 4 -35 -51 -48 -57 -63 -47 -126 4 -30 8 -63 8 -73 1 -15 7 -14
47 14 35 24 43 27 36 12 -6 -11 -27 -33 -46 -50 -20 -16 -34 -32 -32 -34 2 -2
7 -87 10 -189 3 -102 6 -189 6 -195 3 -19 30 119 50 250 26 177 50 380 50 435
-1 40 -2 43 -14 28 -16 -22 -26 -23 -26 -2 0 9 9 18 19 21 18 5 34 36 24 47
-8 8 -43 -18 -43 -31 0 -7 -7 -13 -15 -13 -8 0 -15 6 -15 13 0 15 54 67 69 67
5 0 11 12 15 28 11 48 19 740 11 945 l-7 198 -27 11 c-44 17 -152 46 -148 39z"/>
<path d="M3670 7370 c0 -5 7 -7 15 -4 8 4 15 1 15 -6 0 -6 5 -8 10 -5 18 11
10 25 -15 25 -14 0 -25 -4 -25 -10z"/>
<path d="M2975 7360 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M7300 7362 c0 -12 95 -112 106 -112 5 0 3 5 -4 12 -16 16 -15 31 1
22 7 -4 9 -3 4 2 -5 5 -14 9 -20 9 -7 0 -11 8 -9 17 1 9 -3 20 -9 24 -8 5 -9
3 -4 -6 5 -8 -8 -1 -28 14 -20 16 -37 24 -37 18z"/>
<path d="M2463 7353 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M5090 7350 c-8 -5 -11 -12 -8 -16 4 -3 14 1 23 10 18 17 9 21 -15 6z"/>
<path d="M3226 7333 c-3 -10 -9 -25 -12 -33 -5 -10 0 -9 15 4 21 19 29 46 12
46 -5 0 -11 -8 -15 -17z"/>
<path d="M3729 7333 c-13 -17 -13 -17 6 -3 11 8 22 16 24 17 2 2 0 3 -6 3 -6
0 -17 -8 -24 -17z"/>
<path d="M3006 7315 c4 -16 3 -27 -1 -23 -4 4 -14 0 -21 -10 -11 -14 -14 -14
-14 -2 -1 13 -49 -75 -50 -91 0 -3 12 -4 28 -1 26 4 26 4 7 -11 -33 -25 -11
-29 44 -7 28 11 57 20 64 20 7 0 23 -18 36 -40 26 -42 33 -43 126 -25 28 6 65
42 65 63 -1 16 -2 16 -14 0 -7 -10 -16 -18 -19 -18 -7 0 -4 22 6 37 5 7 -7 20
-33 36 -22 13 -37 26 -34 30 4 3 4 13 0 22 -4 12 -9 13 -24 4 -11 -7 -18 -19
-17 -28 1 -9 0 -10 -2 -3 -4 11 -23 16 -50 13 -7 -1 -13 2 -13 7 0 6 -8 9 -17
8 -9 0 -22 10 -29 22 -8 17 -13 20 -17 10 -4 -10 -8 -10 -17 2 -8 12 -9 8 -4
-15z m34 -28 c0 -7 -9 -18 -21 -25 -17 -11 -20 -11 -13 0 9 15 28 37 32 38 1
0 2 -6 2 -13z m116 -84 c-11 -11 -19 6 -11 24 8 17 8 17 12 0 3 -10 2 -21 -1
-24z m-86 7 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4
10 -10z"/>
<path d="M4421 7329 c-2 -24 -49 -44 -97 -42 -24 1 -46 -3 -49 -8 -13 -20 107
-4 143 20 8 4 12 17 9 27 -3 14 -5 15 -6 3z"/>
<path d="M2461 7281 c-41 -15 -77 -34 -80 -42 -18 -45 -85 -89 -135 -89 -25 0
-51 -22 -39 -33 3 -4 1 -7 -5 -7 -7 0 -12 8 -12 18 -1 9 -8 -3 -17 -28 -13
-37 -14 -56 -5 -110 11 -63 65 -187 123 -280 27 -43 40 -50 19 -9 -10 17 -7
20 20 25 30 7 70 45 70 69 0 6 9 22 19 34 11 13 17 29 14 37 -3 8 -1 14 5 14
5 0 13 11 16 25 4 14 15 34 26 45 11 11 16 20 10 20 -14 0 -12 13 6 36 14 18
15 18 9 -6 -5 -21 -4 -22 5 -8 6 10 18 22 28 28 16 11 16 11 0 6 -23 -7 -23
-4 6 50 14 26 26 40 29 32 3 -7 6 -2 6 10 1 13 10 35 21 49 12 16 20 41 20 64
0 32 -5 40 -34 58 -40 25 -34 26 -125 -8z"/>
<path d="M2448 7293 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M3296 7285 c-3 -8 -1 -15 4 -15 6 0 10 7 10 15 0 8 -2 15 -4 15 -2 0
-6 -7 -10 -15z"/>
<path d="M5027 7283 c-4 -3 -7 -17 -7 -30 0 -12 -4 -23 -9 -23 -5 0 -28 -15
-50 -34 -23 -19 -51 -38 -63 -41 -16 -6 -18 -9 -7 -16 20 -13 41 -11 33 2 -5
8 1 10 19 7 24 -5 26 -3 21 17 -3 13 0 26 6 30 9 5 10 1 5 -14 -4 -12 -2 -21
4 -21 6 0 11 5 11 10 0 6 8 18 18 28 28 29 47 71 36 82 -6 6 -13 7 -17 3z"/>
<path d="M3257 7266 c-7 -17 27 -46 43 -36 9 6 6 10 -9 15 -14 4 -20 12 -17
21 3 8 1 14 -3 14 -5 0 -11 -6 -14 -14z"/>
<path d="M8380 7243 c-6 -133 3 -519 12 -538 8 -19 8 -31 0 -48 -12 -24 -21
-247 -10 -247 4 0 14 14 23 30 15 29 26 36 37 24 7 -6 -51 -97 -64 -102 -4 -2
-8 -31 -7 -65 1 -56 2 -59 12 -34 8 20 17 27 32 25 27 -4 25 -22 -3 -26 -20
-3 -23 -8 -18 -28 5 -18 1 -30 -13 -42 -16 -14 -21 -35 -26 -112 l-6 -95 68
70 c38 39 88 93 111 120 24 28 40 43 36 35 -16 -30 -123 -156 -173 -203 -39
-37 -51 -55 -51 -78 0 -41 -47 -420 -64 -515 -42 -237 -41 -223 -12 -253 18
-17 29 -22 34 -15 9 15 50 0 59 -22 3 -9 1 -25 -5 -35 -7 -10 -12 -20 -12 -22
0 -7 81 -112 87 -112 36 0 179 1062 173 1280 -1 17 1 98 4 180 3 83 3 144 0
138 -3 -7 -15 -14 -27 -14 -17 -1 -18 -2 -4 -6 18 -5 23 -28 8 -37 -18 -12
-22 -57 -6 -73 9 -8 13 -18 10 -21 -3 -3 -11 0 -17 6 -17 17 -23 15 -36 -14
-7 -14 -17 -22 -23 -18 -7 4 -9 0 -5 -14 8 -24 -27 -54 -52 -45 -10 4 -13 2
-8 -5 4 -7 3 -12 -3 -12 -20 0 -21 19 -1 25 17 6 19 9 9 22 -13 15 -9 20 26
38 6 3 5 7 -2 11 -18 8 -16 29 4 45 15 13 16 12 11 -8 -4 -13 -2 -23 2 -23 5
0 16 -3 26 -7 12 -4 15 -3 10 5 -4 7 -2 12 4 12 6 0 8 5 5 10 -4 6 -11 8 -16
4 -5 -3 -9 -2 -8 3 1 4 -1 16 -6 26 -8 18 2 46 35 97 28 43 59 161 66 251 6
74 3 98 -16 160 -12 41 -36 97 -53 125 -26 45 -36 53 -68 58 -39 6 -69 36 -69
68 0 16 -20 37 -20 21z m100 -674 c10 -22 10 -33 2 -41 -12 -12 -15 -7 -26 45
-8 37 8 34 24 -4z"/>
<path d="M2902 7139 c-12 -19 -11 -19 8 -9 11 6 20 15 20 20 0 17 -15 11 -28
-11z"/>
<path d="M2990 7143 c-32 -6 -43 -17 -46 -48 -1 -14 -9 -32 -18 -40 -22 -23
-32 -18 -11 5 15 16 16 23 6 33 -10 9 -15 8 -26 -8 -27 -38 -35 -44 -50 -39
-8 4 -15 2 -15 -4 0 -6 -9 -8 -20 -5 -14 4 -24 -4 -39 -28 -22 -36 -23 -50 -3
-57 7 -2 10 2 6 12 -3 9 -1 16 5 16 6 0 11 -5 11 -11 0 -8 6 -7 17 2 22 19
106 21 99 3 -9 -25 19 -15 30 10 8 18 8 28 1 35 -10 10 2 16 26 12 4 -1 13 12
18 29 6 16 16 30 22 30 19 0 34 14 41 38 8 23 2 25 -54 15z m-12 -38 c-3 -3
-9 2 -12 12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z"/>
<path d="M3072 7120 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M4180 7140 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11
0 -20 -4 -20 -10z"/>
<path d="M4831 7107 c-22 -24 -29 -43 -11 -32 14 8 13 -1 -2 -25 -11 -17 -10
-22 1 -29 9 -6 10 -11 2 -15 -6 -4 -11 -12 -11 -18 0 -7 6 -6 15 2 8 7 15 20
15 30 0 10 7 20 15 24 15 5 22 27 8 25 -20 -3 -24 2 -13 16 7 8 9 15 4 15 -5
0 -3 4 5 9 7 5 9 11 4 14 -6 4 -20 -4 -32 -16z"/>
<path d="M4975 7120 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M7522 7048 c23 -49 48 -88 56 -88 9 0 11 -7 7 -21 -5 -16 -4 -19 5
-14 9 5 10 1 5 -14 -8 -26 24 -118 35 -100 12 19 33 -57 22 -78 -8 -13 -4 -33
14 -73 13 -30 23 -66 23 -80 l1 -25 -20 25 c-11 14 -20 33 -20 43 0 13 -9 17
-41 17 -22 0 -50 5 -61 11 -16 9 -24 7 -36 -5 -11 -10 -12 -16 -4 -16 7 0 12
4 12 9 0 5 9 7 20 4 11 -3 20 -11 20 -18 0 -7 14 -27 30 -45 17 -18 30 -37 30
-43 0 -6 3 -8 6 -4 10 10 64 -22 64 -38 0 -11 -7 -14 -24 -9 -21 5 -24 3 -19
-15 6 -23 23 -29 23 -8 0 8 4 7 10 -3 8 -13 10 -12 10 3 0 24 13 21 25 -5 12
-26 42 -32 54 -11 4 9 5 30 1 49 -4 18 -5 44 -3 57 3 14 -1 35 -8 48 -7 13
-12 29 -11 36 1 6 -7 29 -19 50 -48 85 -92 171 -110 218 -22 59 -23 66 -5 42
9 -12 16 -14 21 -8 3 6 1 11 -4 11 -6 0 -10 3 -10 8 1 4 1 13 0 21 -1 11 -4
11 -14 -3 -12 -16 -16 -12 -47 46 -19 34 -44 74 -57 88 -19 20 -14 6 19 -62z
m156 -353 c-3 -3 -9 2 -12 12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z m32 -26 c0
-6 -4 -7 -10 -4 -5 3 -10 11 -10 16 0 6 5 7 10 4 6 -3 10 -11 10 -16z m0 -49
c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z"/>
<path d="M3185 7090 c-22 -24 -14 -38 8 -15 9 8 20 15 26 15 6 0 11 5 11 10 0
17 -26 11 -45 -10z"/>
<path d="M3116 7035 c-14 -13 -30 -25 -37 -27 -7 -2 -10 -11 -6 -21 7 -19 31
-24 24 -4 -5 16 42 60 59 53 7 -3 16 -1 19 3 12 21 -36 17 -59 -4z"/>
<path d="M7157 7023 c-13 -15 -13 -21 -3 -35 14 -19 36 -24 36 -9 0 5 -6 11
-12 13 -9 3 -8 9 5 22 21 21 21 26 4 26 -8 0 -21 -8 -30 -17z"/>
<path d="M6720 7020 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M3144 6999 c-20 -23 -16 -24 20 -5 20 10 23 15 12 19 -8 3 -22 -3
-32 -14z"/>
<path d="M3676 7011 c-4 -5 3 -7 14 -4 23 6 26 13 6 13 -8 0 -17 -4 -20 -9z"/>
<path d="M6880 6969 c0 -33 3 -40 12 -31 18 18 19 48 3 62 -13 11 -15 6 -15
-31z"/>
<path d="M2995 6981 c5 -17 2 -21 -15 -21 -12 0 -30 -5 -40 -10 -14 -8 -25 -7
-40 2 -17 11 -22 10 -30 -2 -19 -29 -12 -39 20 -30 16 5 38 6 49 3 40 -10 92
53 60 73 -8 4 -9 0 -4 -15z"/>
<path d="M4499 6950 c-21 -17 -21 -19 -4 -13 11 3 25 10 31 14 6 5 15 5 19 1
5 -4 5 -1 1 6 -10 17 -20 15 -47 -8z"/>
<path d="M2690 6945 c10 -12 10 -18 -1 -32 -12 -14 -12 -15 1 -10 8 4 23 10
33 13 26 9 21 21 -14 33 -27 9 -30 9 -19 -4z"/>
<path d="M3100 6950 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M3138 6953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7208 6953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2655 6940 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M4500 6918 c-19 -13 -36 -29 -38 -37 -3 -7 16 1 42 18 25 18 46 34
46 36 0 11 -19 4 -50 -17z"/>
<path d="M7477 6925 c-7 -16 -10 -17 -18 -5 -7 11 -9 4 -9 -25 0 -22 0 -48 0
-59 -1 -28 8 -31 30 -11 24 22 26 43 4 52 -11 4 -12 8 -4 13 6 4 10 18 8 31
-3 22 -4 23 -11 4z"/>
<path d="M6650 6924 c0 -5 7 -18 15 -28 12 -16 15 -17 15 -4 0 8 -7 21 -15 28
-8 7 -15 9 -15 4z"/>
<path d="M3120 6898 c-12 -22 -12 -22 6 -6 10 10 15 20 12 24 -4 3 -12 -5 -18
-18z"/>
<path d="M7295 6910 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4557 6896 c-3 -7 -18 -16 -34 -19 -35 -8 -69 -34 -58 -44 4 -5 10
-3 12 3 2 7 12 10 22 7 17 -4 71 41 71 59 0 13 -7 9 -13 -6z"/>
<path d="M4924 6873 c-11 -19 -8 -53 5 -53 4 0 7 16 8 35 1 41 1 41 -13 18z"/>
<path d="M5167 6883 c-10 -9 -9 -23 2 -23 5 0 11 7 15 15 5 15 -5 20 -17 8z"/>
<path d="M7388 6871 c11 -7 10 -10 -3 -15 -9 -3 -27 -6 -40 -6 -13 0 -27 -4
-30 -10 -3 -5 -19 -10 -36 -10 -19 0 -29 -5 -29 -15 0 -8 6 -15 13 -15 8 0 7
-3 -3 -10 -27 -17 0 -24 29 -7 16 9 42 18 58 19 15 1 34 6 41 11 6 5 12 6 12
2 0 -4 -8 -14 -17 -21 -12 -9 -14 -13 -5 -14 7 0 20 7 28 15 9 8 12 15 7 15
-4 0 -1 6 7 13 8 7 15 22 16 35 0 18 -5 22 -30 22 -21 0 -27 -3 -18 -9z"/>
<path d="M7562 6855 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M4876 6855 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M4890 6830 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M4510 6814 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M4400 6806 c0 -14 29 -31 38 -22 5 5 -23 36 -32 36 -3 0 -6 -6 -6
-14z"/>
<path d="M4475 6809 c-11 -16 -1 -19 13 -3 7 8 8 14 3 14 -5 0 -13 -5 -16 -11z"/>
<path d="M4910 6800 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M4967 6779 c5 -19 3 -20 -18 -14 -19 6 -21 5 -13 -5 7 -6 20 -10 30
-8 23 4 32 48 11 48 -10 0 -13 -7 -10 -21z"/>
<path d="M4890 6770 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7006 6735 c-3 -8 -1 -15 4 -15 13 0 22 18 11 24 -5 3 -11 -1 -15 -9z"/>
<path d="M4983 6723 c-15 -5 -18 -33 -4 -33 5 0 11 9 14 20 3 11 4 20 4 19 -1
0 -8 -3 -14 -6z"/>
<path d="M7495 6717 c-4 -10 -5 -21 -1 -24 10 -10 18 4 13 24 -4 17 -4 17 -12
0z"/>
<path d="M6948 6708 c-28 -22 -27 -68 2 -87 l25 -16 -17 27 c-24 36 -23 52 5
71 12 9 17 16 11 16 -5 1 -17 -5 -26 -11z"/>
<path d="M4385 6700 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M7446 6701 c-3 -5 1 -11 9 -15 8 -3 15 -1 15 4 0 13 -18 22 -24 11z"/>
<path d="M4465 6690 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M5230 6682 c0 -6 5 -14 10 -17 6 -4 7 -11 4 -17 -4 -7 -10 -5 -16 5
-8 15 -38 13 -38 -2 0 -8 79 -46 84 -40 2 2 6 20 10 39 5 27 4 32 -6 22 -9 -9
-16 -8 -30 5 -10 9 -18 11 -18 5z"/>
<path d="M7431 6654 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4448 6653 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4890 6650 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M5946 6636 c-17 -27 -21 -46 -8 -46 9 0 36 59 29 66 -2 2 -12 -7 -21
-20z"/>
<path d="M4711 6604 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5727 6614 c-3 -3 -3 -12 -1 -19 4 -8 -4 -15 -18 -18 -18 -3 -17 -5
8 -6 25 -1 30 3 29 19 -1 23 -9 33 -18 24z"/>
<path d="M4881 6591 c-12 -11 -31 -16 -45 -14 -13 3 -27 0 -30 -6 -4 -6 -2
-11 4 -11 6 0 8 -5 4 -11 -4 -7 -9 -8 -13 -1 -8 14 -111 -18 -111 -35 0 -7 14
-19 30 -28 17 -9 30 -12 30 -8 0 4 5 2 11 -4 9 -9 6 -19 -10 -39 -39 -50 -24
-58 35 -18 21 15 32 19 24 10 -7 -10 -26 -24 -42 -32 -16 -8 -26 -19 -23 -24
3 -5 21 0 40 11 19 12 35 17 35 12 0 -5 -21 -21 -47 -34 l-48 -24 0 -53 c0
-28 -3 -52 -6 -52 -3 0 -19 -12 -34 -26 -15 -14 -34 -23 -41 -20 -8 3 -14 -1
-14 -9 0 -8 -4 -15 -10 -15 -13 0 -13 16 1 41 7 14 16 18 32 14 17 -5 19 -4 7
4 -12 9 -12 11 2 16 18 7 44 62 34 72 -4 4 -16 1 -27 -6 -12 -7 -23 -10 -26
-7 -5 4 50 82 68 96 12 10 30 52 25 58 -3 3 -6 0 -6 -7 0 -6 -10 -16 -22 -21
-13 -5 -17 -9 -10 -9 8 -1 -3 -20 -24 -47 -21 -25 -40 -41 -42 -35 -2 6 -11
11 -19 11 -9 0 -13 -6 -9 -15 3 -8 1 -15 -4 -15 -6 0 -10 7 -10 15 0 8 -3 15
-6 15 -3 0 -12 -7 -20 -15 -14 -13 -14 -15 1 -15 13 0 16 -6 11 -24 -4 -16 -1
-26 8 -29 9 -4 12 -14 9 -28 -5 -19 -11 -21 -56 -16 -54 7 -68 14 -50 25 15 9
21 56 8 62 -14 7 -37 -47 -30 -70 4 -13 22 -22 60 -31 30 -7 55 -15 55 -19 0
-4 -27 -1 -60 7 -37 10 -60 21 -60 29 0 8 -6 14 -12 15 -7 1 -26 3 -43 5 -16
2 -58 5 -91 6 -48 2 -60 6 -56 17 4 11 0 13 -19 8 -13 -4 -32 -7 -41 -7 -14 0
-18 -9 -18 -37 0 -21 -4 -55 -9 -75 -7 -31 -6 -38 6 -38 10 0 12 6 8 20 -5 16
-2 20 14 20 14 0 19 5 15 15 -4 9 1 17 12 21 11 3 30 11 44 17 35 16 158 16
165 0 2 -7 11 -13 19 -13 7 0 17 -7 20 -16 3 -8 10 -13 16 -9 5 3 24 -2 42
-12 24 -12 28 -18 16 -21 -9 -2 -24 -15 -33 -29 -19 -28 -21 -28 30 -7 11 5
13 2 9 -10 -3 -9 -10 -16 -14 -16 -4 0 -10 -9 -13 -20 -4 -17 -1 -19 21 -14
15 4 34 13 43 20 16 15 29 9 29 -12 0 -16 -51 -48 -59 -37 -6 9 -41 -20 -41
-34 0 -4 -20 -8 -45 -8 -29 -1 -52 -8 -66 -21 -22 -18 -22 -18 -15 0 5 16 4
17 -9 6 -8 -7 -12 -17 -9 -22 4 -5 -20 -9 -58 -8 -84 2 -118 -1 -95 -7 9 -2
17 -9 17 -14 0 -5 12 -10 28 -10 l27 -1 -30 -7 -30 -7 25 -9 c14 -5 35 -8 47
-6 11 1 24 -3 28 -8 7 -13 45 -15 45 -3 0 5 33 16 73 25 69 16 95 18 255 18
81 0 124 12 117 31 -3 7 7 20 23 29 23 13 32 13 57 3 17 -8 41 -11 55 -9 14 3
40 1 58 -4 20 -6 30 -6 27 0 -10 15 11 10 24 -5 7 -8 8 -17 3 -20 -15 -9 -2
-98 19 -128 16 -23 16 -28 4 -38 -17 -14 -20 -60 -5 -60 6 0 15 -11 20 -25 8
-21 16 -25 47 -25 21 0 56 5 78 12 22 6 45 11 52 10 6 -2 14 2 17 6 8 13 82
-2 100 -21 9 -9 38 -19 64 -22 26 -4 71 -14 101 -23 l53 -16 34 37 c19 20 40
37 47 37 7 0 17 4 23 10 5 5 33 12 62 15 43 4 52 2 52 -10 0 -13 2 -14 14 -3
10 9 11 15 2 20 -7 5 -5 12 8 21 18 13 21 28 25 115 1 13 5 20 11 17 7 -4 9 2
5 18 -4 14 -2 27 3 31 5 3 7 18 4 32 -4 20 -2 25 8 19 9 -5 10 -2 6 13 -5 15
-1 24 14 32 28 15 38 5 17 -18 -16 -18 -16 -19 4 -17 12 1 27 9 34 18 13 18
30 22 38 10 2 -5 2 -3 1 4 -3 14 21 24 41 17 8 -4 15 -12 15 -20 0 -16 16 -19
25 -4 12 20 22 9 17 -17 -5 -25 -3 -27 11 -14 14 11 18 11 23 -3 8 -20 30 -21
38 -1 3 8 13 15 23 15 15 0 15 -2 -3 -15 -19 -14 -19 -14 0 -15 11 0 17 -3 13
-6 -3 -4 0 -13 8 -21 8 -8 19 -21 24 -31 7 -13 12 -14 24 -4 8 7 17 21 19 30
4 14 -2 18 -25 20 -39 3 -44 7 -45 34 0 33 -19 78 -33 78 -6 0 -9 -9 -6 -20 3
-11 1 -20 -4 -20 -5 0 -9 -7 -9 -15 0 -8 -4 -15 -8 -15 -10 0 -36 70 -28 77 3
3 -2 13 -11 21 -15 15 -17 15 -31 -6 -18 -27 -37 -29 -22 -2 22 42 80 49 80 9
0 -10 4 -19 9 -19 17 0 7 40 -11 46 -10 3 -16 10 -13 15 4 5 -1 9 -9 9 -9 0
-16 5 -16 10 0 15 17 12 36 -7 26 -27 63 -43 81 -36 12 5 15 2 10 -10 -4 -11
0 -15 14 -14 20 1 24 9 12 21 -4 3 -8 16 -10 28 -4 28 -20 46 -46 54 -21 6
-76 44 -64 44 3 0 38 -11 78 -25 56 -18 75 -21 81 -12 12 19 10 21 -22 35 -16
8 -30 18 -30 24 0 6 11 3 25 -6 14 -9 25 -12 25 -6 0 5 -5 10 -10 10 -6 0 -25
15 -42 34 -31 34 -32 34 -66 20 -40 -16 -45 -17 -38 -6 3 5 -21 9 -52 9 -31 1
-51 -1 -44 -4 6 -2 12 -9 12 -14 0 -12 -71 -1 -85 13 -7 7 1 8 23 3 33 -7 47
9 15 19 -95 26 -196 29 -259 6 -30 -10 -61 -17 -67 -14 -7 2 -30 -14 -52 -36
-21 -22 -44 -40 -51 -40 -11 0 -41 -58 -33 -63 40 -22 54 -27 84 -27 19 0 35
4 35 9 0 15 118 53 126 40 3 -5 -1 -9 -8 -10 -7 -1 -2 -4 11 -8 14 -4 26 -13
29 -21 3 -13 2 -13 -6 -1 -6 8 -17 11 -26 8 -8 -3 -18 -2 -22 4 -8 14 -62 1
-94 -23 -16 -12 -44 -19 -75 -20 -41 0 -52 4 -72 26 -17 20 -21 34 -17 53 7
25 6 25 -27 18 -64 -14 -145 -10 -164 8 -14 14 -15 20 -5 32 7 8 16 13 20 10
4 -3 11 3 14 12 5 13 9 14 15 5 5 -9 15 -9 42 0 18 6 40 13 48 15 22 6 6 92
-24 123 -14 14 -25 32 -25 39 0 7 -4 10 -9 7 -14 -9 -92 46 -87 61 3 7 1 13
-4 13 -6 0 -10 -5 -10 -11 0 -6 -8 -8 -19 -4 -11 3 -29 0 -40 -6 -15 -10 -23
-10 -36 1 -13 11 -19 10 -36 -8 -24 -27 -43 -28 -37 -4 16 59 -88 92 -164 53
-35 -18 -37 -18 -41 0 -3 11 -14 19 -25 19 -12 0 -24 5 -27 10 -3 6 1 10 9 10
20 0 29 17 12 23 -8 3 -24 -2 -35 -12z m-31 -63 c0 -7 -11 -26 -25 -43 l-25
-30 5 30 c2 16 12 36 22 42 21 16 23 16 23 1z m217 -17 c18 -24 16 -40 -6 -38
-11 0 -17 5 -15 9 3 4 -4 8 -15 8 -11 0 -23 5 -27 11 -5 9 1 10 20 5 16 -4 26
-2 26 4 0 6 -4 9 -9 6 -5 -3 -15 2 -22 11 -12 14 -11 15 11 8 14 -4 30 -15 37
-24z m-154 -8 c-5 -13 -3 -13 15 -4 17 9 22 9 22 -1 0 -7 -17 -18 -37 -25 -40
-12 -57 -8 -33 7 8 6 10 10 4 10 -6 0 -17 -7 -24 -15 -26 -31 -30 -13 -4 19
18 22 33 32 45 29 11 -3 15 -11 12 -20z m181 21 c18 -7 22 -34 4 -34 -6 0 -8
3 -5 7 4 3 -1 12 -11 19 -18 14 -13 18 12 8z m-121 -85 c-5 -19 -7 -19 -15 -5
-10 18 -2 39 12 31 4 -3 6 -15 3 -26z m177 22 c0 -5 14 -13 31 -16 18 -4 28
-10 23 -14 -5 -3 -16 -15 -24 -26 -14 -17 -12 -17 16 2 23 17 34 19 43 10 8
-8 15 -6 27 11 20 29 48 28 78 -5 l25 -27 -25 -17 c-14 -9 -26 -20 -26 -25 0
-5 -4 -14 -8 -19 -5 -6 -5 -17 -1 -24 14 -22 -31 -61 -70 -61 -26 0 -30 3 -19
10 13 8 13 10 -1 10 -9 0 -32 16 -52 35 -21 20 -37 30 -38 23 0 -10 -2 -10 -6
0 -2 6 -12 12 -21 12 -15 1 -15 2 1 11 24 14 22 59 -4 66 -12 4 -18 11 -15 20
3 8 6 19 6 24 0 5 14 9 30 9 17 0 30 -4 30 -9z m-222 -22 c-25 -14 -23 -32 3
-24 15 5 19 4 15 -4 -4 -6 -18 -11 -32 -11 -17 0 -24 6 -24 19 0 20 13 29 40
30 12 0 11 -2 -2 -10z m107 -9 c18 -8 17 -9 -7 -9 -16 -1 -28 4 -28 9 0 12 8
12 35 0z m-130 -50 c3 -5 -1 -10 -9 -10 -9 0 -16 5 -16 10 0 6 4 10 9 10 6 0
13 -4 16 -10z m-70 -25 c-22 -8 -41 -15 -42 -15 -1 0 0 -6 3 -14 3 -8 -5 -21
-17 -30 -31 -21 -40 -9 -10 15 21 17 21 19 5 19 -12 1 -3 8 21 20 22 11 49 19
60 19 11 0 2 -6 -20 -14z m571 -12 c-5 -11 1 -14 21 -11 15 2 28 -2 30 -9 6
-17 -28 -16 -62 1 -16 8 -22 17 -16 21 6 3 9 11 6 16 -3 5 1 6 10 3 9 -4 14
-13 11 -21z m-265 -42 l23 -18 -32 1 c-23 1 -32 6 -32 19 0 22 12 22 41 -2z
m216 13 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-356 -14 c4 0
9 -10 12 -21 4 -14 11 -20 21 -16 10 4 17 -2 22 -16 8 -24 54 -77 67 -77 9 0
78 -50 88 -63 3 -4 13 -5 22 -1 12 4 17 1 17 -10 0 -9 -7 -16 -15 -16 -24 0
-17 -35 13 -66 48 -51 48 -91 0 -48 -14 14 -20 14 -33 4 -12 -10 -23 -8 -13 3
7 7 -44 65 -62 70 -29 7 -25 -8 6 -22 26 -11 26 -12 9 -31 -10 -11 -22 -20
-27 -20 -13 0 -9 28 5 33 8 4 7 6 -4 6 -9 1 -22 13 -29 27 -8 14 -27 35 -42
46 -16 11 -35 33 -43 49 -9 16 -23 29 -31 29 -14 0 -14 -3 -4 -15 10 -12 10
-19 2 -27 -18 -18 -14 -30 6 -24 11 4 22 -2 30 -15 13 -20 12 -21 -20 -14 -18
4 -35 11 -38 15 -9 13 -48 21 -55 10 -10 -16 -43 -12 -54 7 -5 11 -5 26 0 41
12 31 4 40 -21 24 -23 -14 -25 -5 -5 22 8 10 12 22 10 27 -3 4 -1 11 5 14 18
11 70 -19 83 -47 14 -32 22 -34 43 -13 14 13 13 18 -6 45 -13 18 -30 30 -44
30 -12 0 -31 6 -41 14 -12 9 -29 11 -51 6 -29 -7 -32 -5 -28 13 5 31 16 34
112 30 48 -1 90 -3 93 -3z m1236 -45 c0 -9 -10 -15 -25 -15 -21 0 -22 2 -12
15 7 8 18 15 25 15 6 0 12 -7 12 -15z m-82 -5 c3 -5 1 -10 -4 -10 -6 0 -11 5
-11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-854 -13 c-1 -12 -15 -9 -19 4 -3 6 1
10 8 8 6 -3 11 -8 11 -12z m814 -57 c-3 -5 -14 -10 -23 -9 -14 0 -13 2 3 9 27
11 27 11 20 0z m-598 -22 c-2 -12 -12 -25 -23 -29 -28 -11 -64 -10 -64 1 0 6
10 10 23 10 18 0 19 2 7 11 -13 9 -12 10 3 5 21 -7 49 3 41 15 -3 5 0 9 5 9 6
0 9 -10 8 -22z m-180 -4 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z
m585 -24 c17 0 19 -3 9 -9 -16 -10 -71 6 -71 20 0 6 8 5 19 -1 11 -5 30 -10
43 -10z m-595 -4 c-3 -8 1 -17 9 -20 21 -8 17 -26 -6 -26 -11 0 -20 6 -20 14
0 8 -3 21 -6 30 -4 11 -1 16 11 16 11 0 15 -5 12 -14z m663 4 c-8 -5 -19 -10
-25 -10 -5 0 -3 5 5 10 8 5 20 10 25 10 6 0 3 -5 -5 -10z m-1160 -35 c0 -4 -7
-13 -15 -22 -9 -8 -13 -18 -9 -22 4 -3 9 0 11 7 5 14 33 16 33 2 0 -5 -6 -10
-12 -10 -10 0 -10 -2 -1 -8 7 -4 11 -18 8 -31 -3 -17 0 -21 10 -17 27 10 15
-9 -16 -26 -56 -33 -69 -21 -69 62 0 30 5 52 15 60 8 7 15 19 15 27 0 12 2 12
15 -1 8 -8 15 -17 15 -21z m708 1 c4 -16 -12 -35 -29 -36 -3 0 -17 9 -30 21
-20 17 -21 22 -9 30 24 15 64 6 68 -15z m258 -16 c14 0 23 4 19 9 -3 5 -1 12
5 16 5 3 10 1 10 -5 0 -17 48 -61 55 -50 3 5 15 15 26 21 19 10 20 8 16 -20
-4 -22 -2 -28 9 -24 8 3 14 -1 14 -11 0 -9 -8 -16 -19 -16 -11 0 -23 -4 -26
-10 -3 -5 -13 -10 -20 -10 -21 0 -76 -57 -78 -80 -1 -22 -1 -22 -39 -25 -27
-2 -44 17 -32 37 5 7 -3 9 -22 4 -16 -4 -24 -3 -18 1 6 4 14 19 18 33 5 17 4
21 -2 11 -6 -8 -17 -11 -25 -8 -9 3 -23 -3 -34 -15 -10 -12 -13 -18 -6 -15 18
11 25 -10 12 -35 l-13 -23 -7 25 c-4 14 -7 19 -8 13 -1 -19 -19 -16 -25 5 -5
14 -19 17 -93 17 -87 -1 -89 0 -120 32 -38 39 -40 43 -14 36 10 -3 22 0 25 6
5 7 -1 10 -16 8 -15 -1 -23 4 -26 17 -2 10 0 16 6 12 5 -3 13 1 16 10 4 11 14
15 32 11 18 -3 24 -1 20 9 -3 8 0 11 10 7 7 -3 14 -9 14 -15 0 -5 5 -6 12 -2
6 4 8 3 4 -4 -11 -18 13 -24 30 -8 20 20 28 20 20 1 -3 -9 0 -15 9 -15 8 0 15
-9 15 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -7 -10 -15 0 -25 19 -17 26 11 4 16
11 23 21 20 7 -3 16 1 20 10 4 12 8 13 13 3 6 -9 12 -9 24 4 10 10 12 18 6 22
-5 3 -10 1 -10 -5 0 -6 -5 -8 -11 -4 -18 11 11 24 54 24 38 0 51 15 20 23 -10
2 -2 4 16 4 20 0 37 5 39 13 3 9 7 9 14 -4 5 -9 20 -16 34 -16z m104 10 c0 -5
-4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-509 -18
c-7 -2 -18 1 -23 6 -8 8 -4 9 13 5 13 -4 18 -8 10 -11z m-324 -32 c20 0 11
-24 -12 -28 -10 -2 -15 0 -11 6 3 6 1 12 -6 14 -7 3 -8 9 -3 18 6 10 10 11 13
2 2 -7 10 -12 19 -12z m243 -11 c0 -10 2 -19 4 -19 2 0 12 -3 20 -6 12 -5 15
-2 10 12 -5 16 -4 16 5 4 16 -23 -4 -36 -33 -21 -26 14 -44 63 -19 54 7 -3 13
-14 13 -24z m283 21 c8 0 8 -3 1 -10 -12 -12 -44 -3 -44 12 0 6 7 7 16 4 9 -3
21 -6 27 -6z m-943 -19 c0 -6 -4 -13 -10 -16 -5 -3 -10 1 -10 9 0 9 5 16 10
16 6 0 10 -4 10 -9z m1350 -2 c0 -6 7 -8 16 -5 8 3 12 2 9 -3 -4 -8 -34 -8
-63 -2 -2 1 0 6 3 11 8 14 35 13 35 -1z m-900 -39 c0 -5 -2 -10 -4 -10 -3 0
-8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m-8 -42 c-7 -7 -12 -8 -12 -2
0 14 12 26 19 19 2 -3 -1 -11 -7 -17z m394 -94 c24 -4 28 -12 14 -29 -7 -8
-17 -12 -24 -8 -21 13 -40 12 -51 -4 -12 -16 -50 -15 -47 2 1 6 6 10 11 10 5
0 13 3 17 8 4 4 -2 7 -14 7 -12 0 -22 4 -22 9 0 15 21 25 29 14 3 -5 14 -12
24 -16 13 -5 17 -1 17 21 1 26 1 26 15 8 8 -11 22 -21 31 -22z m282 -36 c-2
-7 5 -12 15 -12 9 1 17 -2 17 -7 0 -12 -37 -11 -45 1 -3 6 -3 15 0 20 9 14 16
13 13 -2z m62 8 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0
10 -2 10 -4z m-312 -33 c-12 -14 -88 -18 -88 -5 0 15 7 17 53 17 35 0 43 -3
35 -12z m343 -60 c-12 -20 -14 -14 -5 12 4 9 9 14 11 11 3 -2 0 -13 -6 -23z"/>
<path d="M4815 6290 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M5470 6008 c0 -7 14 -14 30 -15 17 -1 30 3 30 8 0 6 -7 9 -15 5 -8
-3 -15 -1 -15 4 0 6 -7 10 -15 10 -8 0 -15 -6 -15 -12z"/>
<path d="M5590 5982 c-13 -14 -12 -15 3 -9 10 4 20 0 26 -11 9 -15 10 -15 11
-1 0 27 -23 39 -40 21z"/>
<path d="M5483 5973 c-13 -2 -23 -9 -23 -15 0 -5 7 -7 16 -4 9 3 22 6 30 6 8
0 14 5 14 10 0 6 -3 9 -7 9 -5 -1 -18 -4 -30 -6z"/>
<path d="M5528 5943 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5204 6590 c0 -12 7 -20 18 -20 21 0 33 -17 16 -23 -7 -3 6 -3 30 -1
23 2 42 0 42 -5 0 -5 14 -11 30 -14 17 -4 30 -11 30 -17 0 -6 -4 -8 -10 -5 -5
3 -10 1 -10 -5 0 -12 49 -8 70 5 12 7 -29 34 -64 41 -10 2 -29 10 -42 19 -13
8 -24 12 -24 8 0 -5 -5 -1 -10 7 -7 11 -10 12 -10 2 0 -9 -9 -7 -29 7 -36 26
-37 26 -37 1z"/>
<path d="M5024 6585 c21 -16 32 -13 21 4 -3 6 -14 11 -23 11 -15 -1 -15 -2 2
-15z"/>
<path d="M5168 6593 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4730 6570 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M5158 6563 c6 -2 12 -11 12 -19 0 -12 3 -12 14 -2 12 11 11 14 -3 20
-9 4 -20 7 -26 7 -5 -1 -4 -3 3 -6z"/>
<path d="M5395 6560 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6053 6555 c-3 -9 -3 -18 -1 -21 3 -3 8 4 11 16 6 23 -1 27 -10 5z"/>
<path d="M5750 6554 c0 -13 38 -34 62 -34 45 0 29 24 -20 31 -23 3 -42 4 -42
3z"/>
<path d="M7548 6553 c-27 -7 -21 -22 7 -19 32 3 59 27 30 25 -11 -1 -28 -3
-37 -6z"/>
<path d="M8530 6501 c0 -5 7 -12 16 -15 14 -5 15 -4 4 9 -14 17 -20 19 -20 6z"/>
<path d="M6310 6490 c0 -5 6 -10 14 -10 8 0 16 -6 19 -12 2 -7 7 -10 11 -7 3
3 4 14 0 23 -7 17 -44 23 -44 6z"/>
<path d="M6230 6454 c-35 -32 -40 -42 -40 -80 0 -25 5 -44 11 -44 6 0 8 8 4
19 -3 11 1 26 10 35 9 9 13 17 8 17 -4 1 6 4 22 8 26 6 30 11 28 39 -2 24 0
30 12 26 8 -4 15 -1 15 5 0 21 -30 11 -70 -25z m32 -26 c-7 -7 -12 -8 -12 -2
0 14 12 26 19 19 2 -3 -1 -11 -7 -17z"/>
<path d="M6541 6468 c0 -7 4 -22 9 -33 8 -18 9 -17 9 7 1 15 -3 30 -9 33 -5 3
-10 0 -9 -7z"/>
<path d="M5440 6451 c0 -5 14 -14 31 -20 40 -14 49 -14 49 0 0 6 -6 9 -14 6
-8 -3 -20 1 -26 9 -14 16 -40 19 -40 5z"/>
<path d="M5530 6424 c0 -9 5 -14 12 -12 18 6 21 28 4 28 -9 0 -16 -7 -16 -16z"/>
<path d="M5724 6426 c-11 -8 -15 -18 -10 -23 5 -4 11 -2 13 5 3 6 13 12 24 12
10 0 19 5 19 10 0 14 -23 12 -46 -4z"/>
<path d="M6304 6414 c6 -23 4 -25 -15 -19 -14 5 -19 4 -15 -4 4 -6 17 -10 30
-9 21 2 23 5 14 30 -12 35 -22 37 -14 2z"/>
<path d="M6580 6430 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7680 6418 c0 -9 -7 -18 -15 -22 -20 -7 -19 -46 1 -46 11 0 14 6 9
21 -5 15 -4 19 4 15 6 -4 11 -14 11 -22 0 -8 5 -12 10 -9 14 9 12 37 -5 59
-12 16 -15 17 -15 4z"/>
<path d="M7820 6422 c0 -4 -16 -25 -35 -46 -32 -35 -37 -44 -34 -63 0 -3 -6
-10 -15 -15 -18 -10 -21 -49 -5 -65 6 -6 9 -17 7 -23 -3 -9 -8 -8 -20 4 -9 9
-18 16 -20 16 -2 0 -4 -32 -6 -72 -1 -40 -5 -75 -10 -78 -4 -3 -6 -3 -5 -1 2
2 -2 10 -9 18 -8 10 -8 17 0 25 15 15 16 68 1 68 -6 0 -8 -7 -5 -16 8 -20 -68
-96 -82 -82 -6 6 -12 6 -16 -1 -4 -6 0 -11 8 -11 9 0 16 -5 16 -11 0 -6 6 -17
14 -25 13 -12 15 -12 13 6 -1 11 -5 20 -9 20 -15 0 4 28 22 33 25 6 33 -29 14
-59 -18 -27 -75 -39 -135 -29 -38 7 -44 4 -80 -31 -38 -38 -55 -69 -22 -43 15
12 16 12 10 -3 -4 -11 -2 -18 6 -18 11 0 41 -50 34 -57 -2 -1 -18 2 -37 7 -19
5 -36 7 -39 5 -9 -10 44 -39 65 -37 26 4 41 -15 26 -30 -6 -6 -8 -16 -6 -23 6
-16 -38 -28 -47 -13 -11 17 -28 0 -22 -22 3 -11 0 -26 -6 -34 -7 -8 -11 -20
-10 -28 4 -27 -14 -100 -30 -120 -10 -11 -28 -21 -41 -22 -14 -1 -24 -8 -26
-18 -2 -14 1 -16 16 -8 17 9 17 7 7 -19 -6 -16 -16 -28 -23 -27 -23 4 -45 29
-42 50 2 17 -3 22 -27 24 -16 2 -37 12 -45 23 -21 26 -61 32 -96 14 -16 -8
-34 -15 -40 -15 -6 0 -17 -6 -23 -14 -9 -11 -48 -24 -91 -30 -3 -1 -30 -19
-60 -40 l-55 -40 40 -10 c45 -12 85 -43 85 -65 0 -9 -9 -45 -21 -81 -30 -95
-105 -185 -187 -224 -34 -17 -62 -34 -62 -39 0 -5 7 -4 15 3 12 10 15 9 15 -8
0 -20 -20 -42 -42 -46 -7 -1 -25 -14 -40 -29 -15 -15 -37 -27 -50 -27 -13 0
-41 -11 -63 -25 -40 -24 -97 -37 -65 -14 12 9 11 10 -7 6 -17 -4 -23 -1 -23
11 0 10 -5 24 -11 32 -8 11 -9 7 -5 -17 6 -37 0 -41 -21 -15 -15 18 -15 9 3
-78 9 -44 -14 -38 -32 8 -32 81 -37 89 -42 68 -2 -10 1 -22 8 -26 9 -5 9 -9 1
-14 -14 -9 -51 2 -51 15 0 5 -4 9 -10 9 -24 0 6 -38 75 -94 l30 -24 -25 -10
c-14 -6 -34 -14 -45 -18 -18 -6 -18 -8 -2 -11 9 -3 17 -11 17 -19 0 -17 2 -17
35 -2 19 9 28 9 37 0 15 -15 55 -16 63 -2 3 6 14 10 23 10 10 0 38 11 64 25
26 14 56 25 67 25 11 0 33 11 49 25 17 14 33 25 37 25 8 0 -1 -88 -15 -140 -6
-22 -16 -40 -21 -40 -6 0 -22 -9 -35 -19 -23 -18 -28 -18 -60 -5 -36 15 -142
16 -151 2 -8 -14 -23 -9 -23 7 0 27 -28 27 -67 1 -21 -14 -43 -26 -50 -26 -11
0 -87 -101 -114 -152 -10 -18 -8 -24 6 -34 10 -8 22 -11 26 -8 5 3 6 -2 3 -11
-5 -11 -2 -14 10 -9 9 3 22 1 30 -5 7 -6 36 -12 64 -13 45 -3 52 -6 52 -24 0
-12 8 -24 18 -28 9 -3 24 -9 32 -12 13 -5 13 -4 0 6 -12 8 -9 9 13 4 23 -5 29
-3 34 15 3 11 10 21 17 21 16 1 60 39 53 47 -4 3 -2 14 4 24 7 14 6 17 -4 13
-8 -3 -18 6 -25 21 -11 23 -9 27 11 35 13 5 16 9 7 10 -10 0 -3 11 19 30 18
15 31 33 27 38 -3 5 6 12 20 15 31 5 40 -12 24 -43 -6 -12 -10 -24 -7 -26 2
-3 14 19 27 48 15 35 24 47 27 36 8 -34 -78 -180 -145 -246 -36 -34 -62 -65
-59 -69 10 -10 278 -89 348 -103 64 -13 67 -12 89 8 53 49 138 32 166 -33 15
-37 23 -41 164 -69 170 -34 470 -69 489 -56 31 19 157 299 225 500 90 263 125
458 120 658 -2 78 -2 142 1 142 3 0 9 -10 14 -22 13 -35 23 145 15 281 -4 67
-10 121 -14 121 -4 0 -27 -18 -51 -40 -24 -22 -48 -40 -52 -40 -4 0 -18 -9
-30 -21 -12 -12 -45 -34 -73 -50 -29 -16 -54 -39 -57 -49 -4 -14 -14 -20 -34
-20 -16 0 -45 -12 -64 -26 -70 -53 -171 -91 -261 -98 -55 -4 -36 11 25 19 46
7 133 39 147 54 13 15 80 61 88 61 4 0 19 11 32 25 13 14 35 25 49 25 23 0 82
33 122 68 8 6 42 32 77 57 58 42 62 47 57 78 -9 50 -26 97 -35 97 -18 0 -20
-20 -6 -55 8 -19 12 -35 8 -35 -15 0 -30 16 -33 34 -5 24 -29 34 -29 12 0 -9
-3 -16 -7 -16 -5 0 -20 -10 -35 -23 -41 -34 -60 -49 -103 -82 -22 -16 -47 -38
-55 -47 -8 -10 -25 -20 -37 -23 -22 -4 -72 -51 -73 -69 0 -5 -7 -3 -15 4 -15
12 -16 11 -19 -12 0 -7 -8 -13 -16 -13 -22 0 -125 -70 -149 -100 -10 -14 -23
-25 -28 -23 -14 4 -74 -32 -68 -42 9 -15 -22 -78 -44 -90 -12 -6 -43 -10 -69
-8 -42 2 -56 -3 -135 -55 -72 -47 -89 -62 -94 -88 -6 -34 -28 -48 -46 -30 -6
6 -19 11 -28 11 -16 0 -114 -39 -151 -60 -22 -12 -28 -13 -28 -1 0 6 47 32
103 60 57 28 115 62 130 75 16 15 27 20 30 13 2 -7 37 10 85 43 69 46 81 58
75 75 -17 45 -7 87 25 117 18 15 41 28 52 28 11 0 20 5 20 10 0 6 5 10 11 10
6 0 9 -7 5 -15 -6 -17 9 -21 19 -5 4 6 15 8 26 5 11 -4 19 -2 19 4 0 6 6 11
13 11 15 0 40 47 32 60 -3 5 0 12 6 16 8 4 9 3 5 -5 -9 -14 34 -6 74 15 42 21
103 81 95 94 -5 9 -1 10 14 5 13 -4 21 -2 21 5 0 7 7 10 15 6 8 -3 15 -1 15 5
0 6 6 9 14 6 8 -3 26 5 40 18 14 13 33 26 43 30 10 3 32 17 48 32 l30 25 -38
-22 -37 -22 22 36 c24 36 43 45 52 24 3 -9 12 -5 26 12 12 14 25 25 29 25 4 0
31 20 59 44 l52 45 0 63 c0 40 4 62 10 58 6 -3 10 -17 10 -31 0 -27 15 -32 24
-9 3 8 2 15 -2 15 -4 0 -8 18 -8 39 -2 55 -35 201 -44 196 -5 -3 -6 3 -3 13 2
10 -5 40 -16 67 -11 28 -20 44 -20 38 -1 -7 -6 -13 -11 -13 -7 0 -7 6 0 20 13
24 3 26 -22 3 -17 -15 -18 -15 -18 5 0 12 -4 22 -10 22 -5 0 -7 7 -4 15 4 8 3
15 0 15 -3 0 -6 -4 -6 -8z m90 -114 c0 -5 -4 -8 -10 -8 -5 0 -10 10 -10 23 0
18 2 19 10 7 5 -8 10 -18 10 -22z m40 -205 c0 -26 -3 -44 -6 -40 -9 8 -10 96
-1 90 4 -2 7 -25 7 -50z m-330 -299 c0 -8 -5 -12 -10 -9 -6 4 -8 11 -5 16 9
14 15 11 15 -7z m-160 -74 c0 -16 -4 -30 -10 -30 -5 0 -10 14 -10 30 0 17 5
30 10 30 6 0 10 -13 10 -30z m30 -84 c0 -8 -4 -18 -10 -21 -5 -3 -10 3 -10 14
0 12 5 21 10 21 6 0 10 -6 10 -14z m-90 -65 c0 -5 -7 -14 -15 -21 -12 -10 -15
-10 -15 2 0 8 3 18 7 21 9 10 23 9 23 -2z m-250 -33 c0 -12 -3 -18 -7 -14 -11
10 -12 36 -2 36 5 0 9 -10 9 -22z m877 -100 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z m-1024 -173 c-25 -19 -28 -11 -6 18 13 19 19 21 21 10 2
-8 -5 -21 -15 -28z m534 13 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0
-25z m-37 12 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4
11 -10z m-1073 -446 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z
m-107 -338 c0 -16 -18 -31 -27 -22 -8 8 5 36 17 36 5 0 10 -6 10 -14z m25 -56
c-8 -14 -23 -13 -39 3 -12 10 -10 14 8 24 17 9 23 9 29 -3 4 -8 5 -19 2 -24z
m63 28 c-1 -7 10 -26 25 -42 15 -16 27 -33 27 -37 0 -12 -17 -11 -25 1 -10 16
-29 12 -54 -11 -19 -18 -25 -19 -32 -8 -5 9 -3 16 9 21 9 4 11 7 5 7 -22 1
-14 28 12 45 14 9 23 21 20 26 -4 6 -1 10 5 10 6 0 10 -6 8 -12z m39 -120 c-3
-8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-97 -28 c0 -5 -5 -10 -11
-10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z"/>
<path d="M4595 6410 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M5847 6414 c-8 -8 1 -24 14 -24 5 0 9 7 9 15 0 15 -12 20 -23 9z"/>
<path d="M7726 6403 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M7870 6410 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M2411 6388 c0 -10 -5 -18 -9 -18 -8 0 -37 -81 -48 -133 -12 -53 -21
-181 -17 -221 3 -24 0 -52 -6 -62 -10 -18 -10 -18 -11 4 0 12 -5 22 -10 22 -6
0 -8 -10 -6 -22 30 -139 31 -161 14 -155 -8 2 -12 16 -10 34 2 17 -1 34 -7 38
-7 3 -11 -3 -11 -16 0 -18 -2 -19 -15 -9 -8 7 -12 16 -9 21 3 5 1 16 -4 25 -7
13 -11 9 -16 -21 -6 -29 -10 -35 -17 -24 -6 10 -9 0 -9 -31 0 -25 -2 -73 -4
-107 -2 -46 1 -63 10 -63 18 0 30 -25 44 -92 6 -32 17 -64 24 -70 7 -7 16 -22
20 -33 l8 -20 9 20 c7 18 8 17 6 -5 -1 -14 3 -26 8 -27 6 -1 9 5 7 14 -2 8 0
22 4 32 3 9 8 44 9 79 2 57 9 82 19 71 2 -2 0 -27 -3 -56 -4 -29 -3 -59 2 -69
6 -10 5 -20 -2 -27 -16 -16 -13 -76 4 -93 9 -10 15 -32 14 -57 -2 -63 21 -164
42 -183 18 -16 19 -15 28 7 7 21 12 12 36 -66 15 -49 42 -121 60 -160 18 -38
39 -97 46 -130 7 -33 16 -62 20 -65 3 -3 33 -50 65 -104 33 -55 85 -126 117
-158 31 -33 55 -64 51 -69 -4 -6 -13 -4 -25 7 -10 9 -25 14 -34 10 -9 -3 -13
-2 -10 4 9 15 -4 50 -19 50 -7 0 -22 9 -34 21 -12 11 -27 17 -32 14 -6 -3 -10
-1 -10 4 0 6 5 11 11 11 13 0 -19 44 -80 110 -22 25 -41 48 -41 52 0 5 -9 17
-20 28 -11 11 -20 30 -20 42 0 21 0 21 15 2 15 -18 16 -17 9 16 -10 53 -23 72
-25 35 -1 -16 -5 0 -9 36 -8 67 -62 191 -94 218 -9 8 -23 28 -31 45 -20 42
-71 203 -79 249 -5 24 -12 37 -22 37 -9 0 -18 9 -21 20 -3 11 -9 20 -14 20
-16 0 -10 -18 18 -50 23 -27 27 -42 30 -113 l3 -82 -25 44 c-14 23 -25 48 -26
55 0 6 -10 -20 -22 -57 -12 -38 -25 -66 -29 -62 -10 10 -8 -94 3 -180 16 -118
90 -401 134 -515 68 -175 186 -429 207 -441 19 -12 48 3 49 25 0 11 3 15 6 9
2 -7 13 -13 23 -13 10 0 30 -7 46 -15 32 -16 45 -6 36 27 -3 15 -1 19 9 16 8
-3 14 -10 14 -16 0 -21 15 -25 35 -7 11 10 20 26 20 37 0 21 11 23 28 6 9 -9
12 -9 12 0 0 7 8 12 18 12 24 0 77 37 61 42 -7 2 -14 15 -16 29 -1 13 -8 34
-15 47 -9 18 -9 28 0 42 15 25 15 31 0 25 -9 -4 -14 9 -15 42 -1 43 0 46 12
29 8 -10 16 -22 17 -25 2 -4 17 -17 35 -29 23 -16 31 -29 29 -47 -2 -14 -5
-28 -9 -31 -9 -9 21 -36 32 -30 5 4 11 0 14 -6 5 -15 76 17 193 85 68 40 71
44 67 73 -4 23 1 37 18 57 49 54 128 31 142 -42 5 -25 15 -30 127 -65 89 -28
125 -35 133 -27 16 16 43 14 62 -6 15 -15 27 -15 158 5 267 41 462 72 547 87
175 31 188 35 193 56 3 12 10 18 16 15 5 -4 13 -1 17 5 5 9 11 7 19 -5 11 -15
14 -13 24 15 14 40 14 52 1 44 -5 -3 -10 -1 -10 5 0 6 -10 8 -24 4 -18 -4 -28
0 -38 15 -8 13 -23 21 -40 21 -16 0 -28 5 -28 10 0 6 5 10 10 10 6 0 10 7 10
15 0 18 -12 19 -27 4 -18 -18 -46 -2 -40 22 6 23 -1 49 -13 49 -5 0 -11 -19
-15 -42 -6 -34 -10 -39 -19 -27 -6 8 -19 13 -28 11 -24 -5 -23 7 2 33 24 26
18 65 -6 40 -8 -7 -14 -18 -14 -24 0 -6 -4 -11 -8 -11 -5 0 -14 -12 -21 -26
-6 -15 -14 -24 -17 -21 -4 3 1 20 9 36 12 24 13 31 3 31 -15 0 -49 -123 -35
-128 5 -2 9 -11 9 -20 -1 -14 -3 -14 -16 3 -8 11 -13 30 -11 43 3 17 1 22 -10
18 -10 -4 -17 2 -21 16 -5 21 -6 21 -13 2 -6 -13 -8 -7 -6 21 3 53 -20 57 -52
9 -20 -29 -26 -33 -33 -20 -5 9 -22 16 -38 16 -17 0 -30 5 -30 12 0 6 -7 4
-18 -5 -24 -22 -35 -21 -57 3 -10 11 -25 20 -34 20 -12 0 -13 2 -4 8 24 15
-24 42 -79 45 -57 2 -70 17 -39 44 24 20 28 38 6 29 -8 -3 -15 -1 -15 4 0 6
-7 10 -15 10 -8 0 -15 7 -15 15 0 8 5 15 12 15 6 0 8 3 5 7 -4 3 -21 -6 -37
-22 -17 -16 -30 -24 -30 -18 0 14 -55 29 -112 32 -18 1 -28 7 -28 16 0 8 -4
15 -10 15 -5 0 -19 9 -31 21 l-20 20 3 -37 c2 -31 8 -39 28 -44 17 -4 26 -14
28 -30 2 -14 17 -41 33 -61 16 -20 29 -45 29 -56 0 -10 7 -29 16 -41 18 -26
12 -28 -20 -6 -13 8 -27 26 -30 40 -5 18 -22 31 -64 50 l-58 25 2 117 c2 94 7
127 24 167 19 43 21 62 16 133 -3 46 -8 87 -11 92 -3 5 1 36 8 69 12 49 14 97
8 143 -1 4 -94 71 -208 149 -180 124 -214 143 -253 146 -25 2 -49 8 -54 13
-14 14 -17 48 -6 55 18 11 10 24 -27 49 -59 37 -88 41 -101 11 -7 -15 -8 -25
-2 -25 6 0 10 -4 10 -10 0 -5 -22 4 -49 19 -27 16 -52 27 -54 24 -6 -5 -11 -2
-74 52 -54 47 -60 66 -32 111 12 19 18 39 13 43 -5 4 -51 44 -102 89 -77 69
-96 81 -117 76 -54 -13 -119 30 -130 88 -5 25 -25 49 -35 43 -5 -3 -11 5 -13
17 -3 15 -5 17 -6 6z m-53 -610 c12 -15 27 -86 23 -108 -6 -28 -31 -83 -36
-78 -3 3 -1 32 4 64 7 46 6 64 -5 81 -24 39 -13 73 14 41z m-8 -239 c0 -11 -4
-17 -10 -14 -5 3 -10 13 -10 21 0 8 5 14 10 14 6 0 10 -9 10 -21z m57 -161
c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m946 -252 c4 -10 1 -13
-9 -9 -7 3 -14 9 -14 14 0 14 17 10 23 -5z m-999 -66 c7 -24 6 -24 -8 -6 -9
11 -16 27 -16 35 0 21 16 2 24 -29z m1069 -15 c-10 -13 -21 -25 -25 -25 -12 0
-9 10 7 26 8 9 15 25 15 37 1 20 2 20 11 5 7 -13 5 -24 -8 -43z m-1064 -57
c-1 -40 -1 -41 -9 -15 -8 26 -4 57 6 57 2 0 4 -19 3 -42z m1321 -174 c0 -8 -5
-12 -10 -9 -6 4 -8 11 -5 16 9 14 15 11 15 -7z m792 -299 c2 -21 0 -35 -7 -35
-11 0 -19 46 -9 61 9 15 12 11 16 -26z m-325 3 c-3 -8 -6 -5 -6 6 -1 11 2 17
5 13 3 -3 4 -12 1 -19z m421 -6 c-9 -2 -20 -11 -23 -21 -7 -23 -47 -41 -92
-41 -42 0 -41 6 2 13 45 8 65 18 65 33 0 18 30 33 49 26 14 -6 14 -7 -1 -10z
m-622 -77 c16 -14 25 -25 19 -25 -14 0 -72 49 -59 50 6 0 24 -11 40 -25z m734
21 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z
m-260 -36 c0 -5 -5 -10 -12 -10 -6 0 -40 -13 -75 -30 -68 -32 -77 -35 -68 -21
3 6 29 21 58 34 84 39 97 43 97 27z m-1950 -117 c0 -2 -4 -3 -9 -3 -10 0 -41
73 -40 93 0 10 49 -79 49 -90z m360 81 c0 -8 -4 -12 -10 -9 -5 3 -10 10 -10
16 0 5 5 9 10 9 6 0 10 -7 10 -16z m60 -229 c0 -7 -4 -17 -10 -20 -6 -3 -7 1
-4 9 9 25 -22 19 -40 -6 -9 -12 -19 -19 -22 -15 -4 4 -2 12 3 19 6 8 7 22 2
33 -13 33 -11 34 31 14 22 -11 40 -26 40 -34z"/>
<path d="M5770 6380 c-8 -5 -12 -11 -9 -14 3 -3 14 1 25 9 21 16 8 20 -16 5z"/>
<path d="M6230 6380 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10 5z"/>
<path d="M4710 6355 c-8 -9 -8 -15 -2 -15 12 0 26 19 19 26 -2 2 -10 -2 -17
-11z"/>
<path d="M6303 6346 c15 -13 27 -28 27 -33 0 -6 8 -13 18 -17 9 -3 27 -10 40
-16 14 -6 22 -6 22 0 0 6 -7 10 -15 10 -9 0 -35 18 -59 40 -24 22 -47 40 -52
40 -5 0 3 -11 19 -24z"/>
<path d="M7136 6340 c-10 -19 -12 -29 -5 -22 18 17 39 15 39 -3 0 -8 5 -15 10
-15 6 0 10 -4 10 -10 0 -5 -6 -7 -14 -4 -11 4 -13 0 -9 -15 4 -15 -1 -23 -18
-30 -13 -5 -27 -7 -31 -4 -5 2 -8 -5 -8 -17 0 -12 -4 -19 -10 -15 -5 3 -7 12
-3 20 3 8 0 15 -6 15 -6 0 -11 -12 -11 -27 0 -27 -49 -141 -50 -115 0 6 -5 12
-11 12 -6 0 -9 -7 -6 -14 4 -11 1 -14 -11 -10 -9 2 -7 -1 5 -7 12 -6 24 -18
27 -26 6 -14 -18 -83 -29 -83 -9 0 7 54 19 62 8 5 7 11 -1 19 -9 9 -16 9 -28
-1 -11 -9 -12 -15 -5 -20 7 -4 4 -21 -10 -51 -19 -39 -22 -21 -4 25 7 18 -11
22 -22 5 -4 -7 -8 -28 -10 -47 -2 -19 -11 -40 -21 -48 -10 -7 -13 -14 -8 -14
13 0 57 30 72 50 10 13 11 13 11 0 -3 -43 2 -53 18 -39 8 7 13 21 11 31 -3 10
-1 16 3 13 13 -8 30 29 30 62 0 16 6 37 14 48 12 16 14 13 20 -31 3 -27 2 -65
-4 -84 -14 -47 -13 -49 10 -20 15 20 20 21 20 8 0 -35 15 -24 17 13 0 21 -3
39 -8 39 -6 0 -5 9 1 20 9 17 7 24 -12 40 -18 15 -21 21 -10 31 9 10 12 10 12
0 0 -7 4 -10 9 -6 6 3 14 -3 20 -12 9 -17 10 -17 16 0 8 20 25 23 25 3 0 -8 8
-13 18 -12 10 0 17 -6 16 -16 -1 -10 4 -14 12 -11 7 3 34 -10 59 -28 l46 -33
30 30 c33 33 32 70 -2 61 -21 -6 -26 8 -6 17 6 3 0 3 -14 0 -19 -4 -34 1 -53
19 -34 32 -33 44 2 19 29 -21 57 -17 57 8 0 9 7 14 19 12 13 -2 16 0 10 10 -5
7 -7 24 -6 38 2 23 1 23 -7 5 -5 -11 -12 -28 -15 -37 -6 -19 -26 -25 -26 -8 0
6 5 10 11 10 14 0 -28 33 -56 45 -19 8 -29 10 -67 13 -11 1 -18 10 -18 22 0
11 -5 20 -11 20 -5 0 -7 5 -4 11 4 6 29 9 56 8 27 -2 52 0 55 4 4 4 -14 7 -39
7 -42 0 -48 3 -62 30 -9 17 -20 30 -25 30 -4 0 -10 8 -12 18 -3 13 -9 8 -22
-18z m134 -160 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4
4 -10z m45 -20 c3 -5 -1 -10 -9 -10 -9 0 -16 5 -16 10 0 6 4 10 9 10 6 0 13
-4 16 -10z"/>
<path d="M6871 6340 c-11 -6 -9 -11 9 -20 12 -6 24 -9 28 -6 3 3 0 6 -7 6 -7
0 -10 4 -6 9 8 14 -8 21 -24 11z"/>
<path d="M6570 6305 c0 -8 4 -15 10 -15 5 0 7 7 4 15 -4 8 -8 15 -10 15 -2 0
-4 -7 -4 -15z"/>
<path d="M4530 6302 c0 -12 19 -26 26 -19 2 2 -2 10 -11 17 -9 8 -15 8 -15 2z"/>
<path d="M5561 6301 c-7 -5 -10 -14 -6 -20 5 -9 10 -9 21 0 26 22 14 38 -15
20z"/>
<path d="M7265 6300 c-4 -6 3 -10 14 -10 25 0 27 6 6 13 -8 4 -17 2 -20 -3z"/>
<path d="M7316 6272 c-2 -4 -1 -14 5 -22 7 -12 9 -10 9 8 0 23 -5 28 -14 14z"/>
<path d="M2696 6240 c21 -36 159 -156 215 -188 28 -16 39 -18 48 -9 9 9 11 7
6 -8 -6 -18 -4 -17 14 4 12 12 18 27 15 33 -3 5 2 8 12 6 23 -4 34 -27 24 -53
-8 -24 -2 -47 11 -40 5 4 16 -9 25 -28 16 -34 57 -66 102 -79 12 -3 22 -5 22
-4 0 23 -36 97 -50 101 -10 3 -21 16 -24 29 -3 14 -19 29 -36 36 -17 7 -33 22
-36 34 -4 16 -46 43 -162 103 -86 44 -168 84 -181 88 l-23 7 18 -32z"/>
<path d="M6435 6250 c-4 -12 -5 -24 -2 -27 3 -2 8 5 12 17 4 12 5 24 2 27 -3
2 -8 -5 -12 -17z"/>
<path d="M7695 6250 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M2221 6224 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7340 6209 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M7660 6210 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6430 6200 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M4380 6184 c0 -7 40 -44 47 -44 7 0 3 7 -16 28 -18 22 -31 28 -31 16z"/>
<path d="M6440 6156 c0 -8 9 -21 21 -29 13 -10 17 -17 10 -22 -6 -3 -9 -11 -5
-16 4 -6 11 -6 20 2 11 9 14 8 14 -5 0 -9 -7 -16 -15 -16 -8 0 -15 -4 -15 -9
0 -5 7 -14 15 -21 9 -8 15 -8 15 -2 0 6 -6 13 -12 15 -7 3 -3 6 10 6 20 1 21
-2 12 -19 -17 -31 -54 -42 -86 -25 -15 8 -31 12 -36 9 -4 -3 -8 2 -8 11 0 9
-5 25 -10 36 -9 15 -15 17 -31 9 -15 -9 -17 -15 -9 -30 12 -22 13 -51 3 -49
-22 4 -43 -2 -43 -11 0 -7 7 -7 20 0 16 9 22 8 27 -5 5 -13 7 -14 14 -3 7 11
11 10 18 -2 5 -8 8 -17 5 -21 -5 -8 27 -22 34 -14 3 3 -1 5 -8 5 -10 0 -11 3
-3 11 7 7 16 7 29 0 11 -5 35 -15 54 -21 34 -10 36 -9 65 26 36 45 73 83 105
107 l24 17 -29 0 c-23 0 -27 -3 -15 -10 13 -8 13 -10 -1 -10 -9 0 -22 -7 -29
-15 -7 -8 -16 -12 -21 -10 -4 3 -19 -7 -33 -22 -19 -20 -22 -29 -13 -36 8 -6
6 -7 -6 -3 -10 3 -23 6 -28 6 -5 0 0 9 12 21 14 14 19 28 15 42 -4 12 -9 37
-13 55 -4 23 -11 32 -25 32 -10 0 -21 7 -24 15 -8 19 -24 20 -24 1z"/>
<path d="M4500 6150 c0 -6 7 -10 15 -10 8 0 15 2 15 4 0 2 -7 6 -15 10 -8 3
-15 1 -15 -4z"/>
<path d="M4305 6109 c-45 -21 -72 -24 -77 -8 -2 6 -11 7 -22 3 -19 -7 -19 -8
0 -15 35 -14 83 -9 124 12 65 34 44 41 -25 8z"/>
<path d="M4395 6090 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M6585 6090 c-3 -5 1 -10 10 -10 9 0 13 5 10 10 -3 6 -8 10 -10 10 -2
0 -7 -4 -10 -10z"/>
<path d="M6923 6070 c-46 -28 -41 -35 7 -10 38 19 49 30 33 30 -5 0 -23 -9
-40 -20z"/>
<path d="M4470 6069 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M6720 6072 c0 -5 -12 -13 -27 -19 l-28 -11 28 -1 c15 -1 27 4 27 9 0
6 9 10 20 10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11 0 -20 -4 -20 -8z"/>
<path d="M4439 6026 c14 -14 26 -24 29 -22 7 8 -8 25 -31 37 -21 11 -21 10 2
-15z"/>
<path d="M7171 6034 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6284 6024 c-17 -14 -17 -15 -1 -10 10 3 23 6 28 6 5 0 9 5 9 10 0
14 -13 12 -36 -6z"/>
<path d="M6643 6013 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z"/>
<path d="M6775 6010 c3 -5 -3 -10 -15 -10 -12 0 -18 -4 -15 -10 6 -9 55 -15
55 -6 0 14 -14 36 -22 36 -5 0 -6 -4 -3 -10z"/>
<path d="M6875 6011 c-28 -6 -28 -7 -8 -13 13 -4 27 0 34 8 6 8 10 13 8 13 -2
-1 -17 -4 -34 -8z"/>
<path d="M4265 5985 l-40 -13 56 2 c40 1 55 5 52 14 -6 15 -16 14 -68 -3z"/>
<path d="M6860 5980 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M6596 5965 c-11 -8 -18 -17 -15 -19 2 -3 15 4 29 14 14 11 21 20 15
19 -5 0 -19 -6 -29 -14z"/>
<path d="M6903 5968 c-6 -7 -16 -24 -23 -38 -12 -24 -11 -24 19 4 17 17 31 33
31 38 0 12 -16 10 -27 -4z"/>
<path d="M2270 5961 c0 -6 5 -13 10 -16 6 -3 10 1 10 9 0 9 -4 16 -10 16 -5 0
-10 -4 -10 -9z"/>
<path d="M6710 5925 c-7 -9 -10 -18 -6 -22 3 -3 6 -1 6 5 0 7 7 12 15 12 8 0
15 5 15 10 0 15 -16 12 -30 -5z"/>
<path d="M6409 5917 c6 -8 8 -17 4 -20 -3 -4 1 -7 10 -7 20 0 22 11 5 28 -16
16 -33 15 -19 -1z"/>
<path d="M2162 5895 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M7163 5870 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z"/>
<path d="M6810 5903 c0 -7 5 -15 11 -19 8 -4 8 -9 0 -17 -14 -14 -14 -67 0
-67 6 0 8 -7 5 -16 -4 -9 -2 -13 5 -8 6 3 9 22 7 40 -5 41 -3 42 16 7 8 -16
15 -23 16 -16 0 13 -35 81 -51 98 -6 5 -9 5 -9 -2z"/>
<path d="M4968 5893 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7090 5880 c-21 -21 -20 -35 2 -100 5 -17 7 -8 3 28 -4 53 -4 54 20
48 23 -6 44 9 30 22 -3 3 -10 0 -14 -7 -6 -9 -11 -10 -15 -2 -4 6 -4 16 -1 21
10 17 -4 11 -25 -10z"/>
<path d="M6350 5882 c-17 -6 -49 -43 -50 -56 0 -6 5 -5 12 2 7 7 22 12 34 12
12 0 24 7 28 15 3 8 10 15 17 15 6 0 9 -6 6 -14 -3 -8 -1 -17 6 -20 7 -2 5 -5
-5 -5 -9 -1 -18 -6 -20 -12 -3 -9 -10 -9 -27 0 -12 7 -25 10 -28 8 -10 -10 18
-47 37 -48 11 -1 25 -3 30 -4 6 -1 16 -3 23 -4 6 -1 29 -17 49 -36 20 -19 43
-35 50 -35 10 0 10 -2 0 -8 -9 -6 -5 -12 13 -22 14 -7 36 -28 50 -46 19 -24
30 -31 46 -27 15 4 20 3 15 -5 -5 -9 0 -9 18 -2 34 13 61 3 45 -16 -9 -11 -8
-14 5 -14 9 0 16 7 16 15 0 8 4 15 10 15 5 0 7 6 4 14 -3 8 -1 17 5 21 6 3 11
0 11 -8 0 -10 7 -13 20 -10 14 4 20 0 20 -10 0 -10 6 -13 19 -10 10 3 22 0 25
-6 4 -6 16 -11 28 -11 17 0 18 2 8 15 -7 8 -22 15 -34 15 -11 0 -27 4 -35 9
-23 15 4 39 47 43 30 3 33 5 17 11 -45 17 -69 33 -79 51 -11 20 -15 26 -42 61
-15 19 -15 19 -9 -5 4 -14 8 -34 10 -45 2 -11 4 -22 4 -25 1 -3 6 2 11 10 7
10 9 -2 8 -40 -1 -30 -3 -48 -5 -39 -6 26 -39 30 -40 6 -2 -23 -20 -44 -29
-34 -4 4 -1 13 6 22 7 8 8 15 3 15 -5 0 -17 -9 -26 -21 -19 -22 -38 -21 -45 1
-3 7 0 10 5 7 5 -3 10 0 10 7 0 8 -8 11 -19 8 -10 -2 -18 1 -18 8 0 7 -8 9
-20 5 -23 -7 -28 13 -5 21 8 4 15 12 15 20 0 8 5 14 11 14 6 0 9 -9 6 -20 -3
-11 -1 -20 4 -20 18 0 24 -3 35 -18 8 -11 15 -12 30 -4 16 10 16 11 3 12 -10
0 -16 7 -15 18 1 12 -6 17 -21 16 -13 0 -23 5 -23 12 0 21 -27 23 -48 4 -19
-18 -21 -18 -35 -2 -8 9 -12 24 -9 32 5 13 3 13 -12 1 -13 -11 -20 -11 -28 -3
-9 9 -7 12 8 12 14 0 16 2 5 9 -7 5 -10 14 -7 20 4 6 -4 16 -18 23 -14 6 -26
15 -26 20 0 5 -8 8 -17 6 -10 -2 -22 7 -29 22 -14 26 -41 40 -64 32z m260
-262 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
<path d="M6593 5868 c-13 -6 -23 -15 -23 -20 0 -10 36 7 45 22 7 12 7 12 -22
-2z"/>
<path d="M6494 5845 c8 -8 21 -15 29 -15 8 0 18 -7 21 -16 3 -8 10 -12 16 -9
5 3 10 1 10 -4 0 -6 5 -11 11 -11 6 0 9 8 7 18 -2 9 -9 16 -16 15 -6 -2 -26 6
-44 17 -39 24 -55 26 -34 5z"/>
<path d="M8012 5799 c4 -35 11 -65 14 -68 9 -9 -7 112 -16 122 -4 4 -3 -20 2
-54z"/>
<path d="M6721 5814 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4240 5810 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"/>
<path d="M7850 5805 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20 -6z"/>
<path d="M6989 5774 c-22 -25 -22 -26 -3 -16 12 6 24 18 28 27 8 21 3 19 -25
-11z"/>
<path d="M6695 5760 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M6640 5739 c14 -11 33 -27 43 -35 9 -7 24 -14 31 -14 8 0 16 -5 18
-11 2 -7 10 -10 16 -8 20 7 -47 69 -74 69 -13 0 -24 5 -24 10 0 6 -8 10 -17
10 -15 -1 -13 -4 7 -21z"/>
<path d="M6880 5753 c1 -20 60 -63 60 -43 0 5 -4 10 -8 10 -5 0 -18 9 -30 20
-12 12 -22 17 -22 13z"/>
<path d="M7027 5753 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M7800 5749 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4214 5728 c-7 -11 18 -10 36 2 11 7 10 9 -8 7 -13 -1 -26 -5 -28 -9z"/>
<path d="M5898 5727 c-5 -10 -8 -35 -7 -55 0 -35 1 -35 10 -12 6 13 9 38 7 55
-2 24 -4 26 -10 12z"/>
<path d="M7320 5712 c0 -10 -5 -23 -12 -30 -9 -9 -8 -12 5 -12 9 0 17 6 17 14
0 8 3 21 6 30 3 9 1 16 -5 16 -6 0 -11 -8 -11 -18z"/>
<path d="M4200 5698 c-19 -5 -39 -13 -45 -18 -5 -4 -29 -10 -53 -14 -24 -3
-51 -10 -60 -16 -33 -19 84 -2 131 19 25 12 53 21 61 21 9 0 16 5 16 10 0 12
-3 12 -50 -2z"/>
<path d="M4938 5673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7641 5650 c-13 -11 -19 -20 -13 -20 5 0 20 9 33 20 13 10 20 19 14
19 -5 0 -21 -9 -34 -19z"/>
<path d="M6443 5648 c-13 -6 -23 -19 -23 -28 0 -23 58 -95 88 -109 12 -6 22
-16 22 -23 0 -7 8 -22 16 -33 15 -19 15 -19 9 10 -5 23 -4 26 4 15 10 -13 15
-8 12 13 0 4 4 7 10 7 8 0 7 6 -2 17 -12 15 -12 16 6 11 11 -3 29 -9 40 -13
16 -5 17 -5 5 4 -11 8 -3 9 32 6 26 -3 49 -1 52 3 2 4 -16 7 -40 7 -32 1 -49
7 -64 23 -12 12 -32 22 -45 22 -14 0 -25 3 -25 8 0 11 -57 72 -67 71 -4 0 -18
-5 -30 -11z m144 -104 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M7327 5646 c-4 -10 -1 -13 9 -9 7 3 14 9 14 14 0 14 -17 10 -23 -5z"/>
<path d="M4165 5640 c-18 -8 -17 -9 7 -9 15 -1 30 4 33 9 7 12 -12 12 -40 0z"/>
<path d="M4120 5619 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M7346 5613 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M4062 5594 c-22 -21 -22 -22 -3 -17 23 6 46 29 34 35 -4 3 -18 -6
-31 -18z"/>
<path d="M5728 5613 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M2121 5584 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5195 5590 c6 -9 -1 -11 -26 -6 -19 3 -27 3 -19 -2 8 -4 27 -15 43
-26 22 -15 30 -16 42 -6 19 16 19 27 0 27 -8 0 -15 -4 -15 -9 0 -5 -5 -6 -10
-3 -6 4 -8 10 -5 15 3 5 0 12 -6 16 -8 5 -9 3 -4 -6z"/>
<path d="M5690 5597 c0 -3 10 -11 23 -20 20 -13 24 -13 37 1 13 14 12 15 -4 9
-9 -4 -26 -2 -37 3 -10 6 -19 9 -19 7z"/>
<path d="M6748 5573 c-8 -10 -15 -33 -15 -51 0 -25 3 -29 9 -18 5 9 18 16 28
16 11 0 20 5 20 11 0 5 -5 7 -12 3 -6 -4 -8 -3 -5 4 4 5 3 20 -1 32 -8 20 -9
20 -24 3z"/>
<path d="M5890 5545 c0 -8 -9 -20 -20 -27 -11 -7 -20 -19 -20 -27 0 -11 4 -10
15 5 15 18 15 18 13 -6 -4 -37 -28 -30 -65 18 -18 24 -33 40 -33 35 0 -4 9
-19 20 -33 11 -14 20 -31 20 -37 0 -7 4 -13 9 -13 5 0 24 -30 43 -67 18 -38
43 -83 55 -101 13 -19 19 -40 15 -54 -3 -14 -2 -19 6 -14 7 4 12 3 12 -2 0 -5
9 -12 21 -15 12 -3 18 -10 15 -15 -3 -5 3 -12 14 -15 11 -3 20 -11 20 -17 0
-10 -3 -10 -15 0 -10 8 -15 9 -15 2 0 -6 9 -16 20 -22 14 -8 20 -21 20 -48 0
-41 7 -56 30 -64 12 -4 16 2 18 24 1 17 5 34 8 39 5 9 65 6 82 -5 8 -5 10 -1
6 9 -4 9 -17 21 -30 25 -18 7 -28 25 -41 70 -14 47 -26 66 -55 87 -20 16 -44
43 -53 62 -24 51 -98 142 -106 130 -3 -6 -4 12 -1 40 2 28 2 51 -2 51 -3 0 -6
-7 -6 -15z"/>
<path d="M2132 5520 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M5912 5513 c26 -53 35 -64 64 -73 19 -7 34 -16 34 -21 0 -5 7 -9 15
-9 20 0 -9 28 -51 50 -16 9 -33 26 -39 38 -5 12 -14 22 -18 22 -5 0 -7 -3 -5
-7z"/>
<path d="M2236 5483 c-4 -13 -14 -23 -22 -23 -11 0 -14 -16 -14 -72 l1 -73 25
75 c14 41 23 84 22 95 -4 19 -4 19 -12 -2z"/>
<path d="M5810 5433 c0 -4 5 -15 10 -23 8 -13 10 -13 10 2 0 9 -4 20 -10 23
-5 3 -10 3 -10 -2z"/>
<path d="M6633 5424 c-5 -13 -7 -13 -14 -2 -7 10 -9 9 -9 -4 0 -22 33 -24 50
-3 11 13 10 14 -5 9 -13 -5 -16 -4 -11 4 4 7 5 12 1 12 -3 0 -8 -7 -12 -16z"/>
<path d="M6808 5414 c6 -3 12 -11 12 -18 0 -7 16 -11 40 -11 37 0 51 7 33 18
-5 3 -28 7 -53 11 -25 3 -39 3 -32 0z"/>
<path d="M6131 5401 c-9 -6 -12 -18 -7 -36 8 -33 19 -26 21 15 1 16 1 30 1 30
-1 0 -7 -4 -15 -9z"/>
<path d="M6060 5386 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 -5 3
-10 -1 -10 -9z"/>
<path d="M5840 5381 c0 -5 6 -14 14 -20 12 -10 13 -8 9 8 -5 21 -23 30 -23 12z"/>
<path d="M6035 5350 c-9 -15 14 -40 37 -40 10 0 16 5 13 10 -3 6 -15 10 -26
10 -21 0 -26 16 -6 23 9 4 9 6 0 6 -6 1 -15 -4 -18 -9z"/>
<path d="M2375 5341 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z"/>
<path d="M3690 5309 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M5890 5301 c0 -5 7 -14 15 -21 16 -14 18 -10 9 14 -6 17 -24 22 -24
7z"/>
<path d="M6120 5285 c-11 -20 -11 -28 -1 -38 10 -9 11 -8 5 6 -4 13 -2 16 9
12 11 -5 13 0 10 19 -6 32 -7 32 -23 1z"/>
<path d="M6867 5240 c-3 -11 -1 -20 4 -20 5 0 9 9 9 20 0 11 -2 20 -4 20 -2 0
-6 -9 -9 -20z"/>
<path d="M6147 5230 c-3 -10 1 -26 7 -36 10 -13 12 -10 8 20 -5 41 -8 44 -15
16z"/>
<path d="M5820 5229 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M3685 5190 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M5226 5175 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M5941 5164 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6174 5157 c3 -10 6 -21 6 -23 0 -2 10 -4 22 -4 12 0 19 2 17 4 -2 2
-7 4 -11 3 -4 -1 -14 7 -23 18 -15 18 -16 18 -11 2z"/>
<path d="M5190 5119 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M5217 5113 c-4 -3 -7 -19 -7 -35 0 -16 -4 -27 -9 -24 -5 4 -7 -3 -4
-14 5 -20 18 -26 26 -12 3 4 8 26 12 50 6 39 -1 53 -18 35z"/>
<path d="M6010 5101 c0 -11 4 -22 9 -25 5 -3 8 5 7 19 -1 29 -16 34 -16 6z"/>
<path d="M8181 4943 c-68 -280 -147 -518 -262 -786 -32 -77 -59 -142 -59 -145
1 -12 40 43 40 55 0 6 5 15 11 18 5 4 3 -9 -5 -29 -8 -20 -11 -36 -5 -36 5 0
9 5 9 10 0 6 11 10 24 10 13 0 27 6 30 13 4 6 4 2 2 -10 -2 -13 -1 -25 2 -27
4 -2 50 0 102 5 67 7 99 14 107 26 26 33 147 425 197 633 51 215 50 198 20
239 -55 73 -159 201 -164 201 -3 0 -25 -80 -49 -177z"/>
<path d="M5112 5085 c0 -16 2 -22 5 -12 2 9 2 23 0 30 -3 6 -5 -1 -5 -18z"/>
<path d="M5147 5060 c-3 -11 -2 -20 2 -20 3 0 12 9 19 20 10 16 10 20 -2 20
-7 0 -16 -9 -19 -20z"/>
<path d="M6023 5035 c0 -8 4 -15 9 -15 4 0 8 4 8 9 0 6 -4 12 -8 15 -5 3 -9
-1 -9 -9z"/>
<path d="M6229 5030 c-7 -49 -6 -59 6 -63 9 -4 12 1 9 16 -3 16 -1 15 8 -5 13
-31 42 -40 31 -10 -7 18 -52 71 -54 62z"/>
<path d="M6288 5013 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2034 4973 c4 -10 4 -14 0 -11 -8 9 -55 -42 -48 -53 3 -5 -1 -6 -8
-4 -8 3 -18 -6 -25 -25 -6 -16 -18 -30 -26 -30 -14 0 -37 -28 -63 -75 -7 -15
-7 -37 4 -85 8 -36 18 -69 22 -73 4 -5 15 21 25 57 17 62 27 77 39 58 2 -4 -9
-39 -25 -77 -16 -38 -29 -75 -29 -82 0 -17 83 -300 109 -373 42 -119 72 -194
111 -285 22 -52 40 -99 40 -104 0 -5 17 -13 38 -19 25 -7 30 -10 15 -11 -25
-1 -28 -8 -14 -30 12 -19 41 -6 41 19 0 11 5 20 11 20 6 0 9 -7 5 -15 -7 -19
8 -19 28 0 8 8 23 14 33 13 47 -4 52 1 47 40 -2 20 -2 31 2 25 10 -22 26 -14
19 10 -5 17 -4 19 4 7 8 -12 11 -12 11 -1 0 8 8 4 20 -10 l21 -24 -16 32 c-23
49 -18 64 7 16 38 -75 44 -53 6 25 l-37 75 -89 23 c-96 25 -221 69 -236 84 -5
5 31 -4 80 -19 101 -32 174 -44 174 -29 0 5 7 2 16 -6 8 -9 19 -16 24 -16 11
0 5 15 -40 115 -74 163 -187 489 -246 707 -21 82 -43 148 -48 148 -4 0 -5 -8
-2 -17z"/>
<path d="M6121 4904 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6150 4911 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M6167 4816 c5 -30 1 -39 -34 -73 -22 -21 -43 -46 -46 -55 -4 -10 -14
-18 -23 -18 -19 0 -15 7 53 80 48 51 52 60 22 60 -11 0 -18 -4 -14 -9 3 -6 -3
-15 -14 -20 -26 -15 -31 -14 -25 4 4 8 1 15 -5 15 -6 0 -11 -4 -11 -10 0 -5
-25 -36 -55 -67 -30 -32 -55 -63 -55 -69 0 -15 -26 -25 -45 -18 -8 4 -15 1
-15 -4 0 -20 23 -61 31 -57 4 3 10 1 14 -5 4 -6 -9 -10 -34 -10 -23 0 -41 -3
-41 -7 1 -20 41 -53 62 -53 18 0 28 -9 39 -32 8 -18 20 -32 27 -30 6 1 12 -5
12 -13 0 -8 5 -15 10 -15 6 0 10 6 10 13 0 8 4 7 10 -3 9 -13 11 -13 20 0 9
14 15 7 11 -14 -1 -5 5 -6 14 -2 9 3 19 6 21 6 2 0 4 8 4 18 0 9 9 28 20 42
11 14 20 36 20 50 0 19 2 22 10 10 7 -12 10 -11 16 5 4 11 17 34 29 50 12 17
25 39 27 50 3 11 9 29 14 39 5 14 4 17 -5 11 -10 -6 -11 -3 -2 14 10 17 9 21
-4 21 -8 0 -15 9 -15 20 0 11 5 20 10 20 6 0 10 9 10 20 0 13 -7 20 -19 20
-12 0 -21 9 -25 25 -10 40 -36 32 -29 -9z m-3 -191 c-4 -8 -8 -15 -10 -15 -2
0 -4 7 -4 15 0 8 4 15 10 15 5 0 7 -7 4 -15z m-219 -14 c3 -5 1 -12 -5 -16 -5
-3 -10 1 -10 9 0 18 6 21 15 7z m195 5 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10
4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-110 -46 c0 -5 -4 -10 -10 -10 -5 0 -10 5
-10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m55 -20 c-3 -5 -11 -10 -16 -10 -6 0
-7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z m-145 -30 c0 -5 -2 -10 -4 -10 -3
0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z"/>
<path d="M6250 4782 c0 -10 -5 -23 -12 -30 -6 -6 -8 -15 -4 -19 4 -4 10 -3 14
2 4 6 21 17 37 25 28 13 29 14 7 18 -12 2 -20 8 -17 13 4 5 -1 9 -9 9 -9 0
-16 -8 -16 -18z"/>
<path d="M6577 4748 c-32 -11 -56 -22 -53 -25 8 -8 116 27 116 37 0 6 -1 9 -2
9 -2 -1 -29 -10 -61 -21z"/>
<path d="M6520 4685 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20 -6z"/>
<path d="M6453 4669 c-18 -5 -33 -14 -33 -19 0 -6 17 -3 37 5 60 25 58 32 -4
14z"/>
<path d="M6576 4671 c-4 -5 -2 -12 3 -15 5 -4 12 -2 15 3 4 5 2 12 -3 15 -5 4
-12 2 -15 -3z"/>
<path d="M6530 4650 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M4490 4610 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M4930 4598 c0 -19 2 -20 10 -8 13 19 13 30 0 30 -5 0 -10 -10 -10
-22z"/>
<path d="M4610 4600 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M4770 4590 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0
-15 -4 -15 -10z"/>
<path d="M5760 4550 c0 -27 3 -30 33 -29 l32 1 -29 7 c-26 5 -28 7 -13 20 23
18 21 31 -3 31 -16 0 -20 -7 -20 -30z"/>
<path d="M4805 4560 c4 -6 -8 -10 -29 -10 -25 0 -38 -6 -46 -20 -8 -16 -8 -20
4 -20 8 0 17 6 19 13 4 9 8 8 16 -3 9 -13 12 -13 20 -1 5 8 16 11 25 8 9 -4
16 -2 16 4 0 6 7 8 16 5 9 -4 23 -1 30 5 11 9 14 9 14 0 0 -7 5 -9 10 -6 17
11 -7 33 -35 33 -14 0 -22 -4 -19 -9 3 -5 -7 -4 -21 1 -17 7 -24 7 -20 0z"/>
<path d="M4930 4541 c0 -11 -6 -21 -12 -24 -7 -2 -10 -8 -6 -12 10 -10 48 23
48 42 0 7 -7 13 -15 13 -8 0 -15 -9 -15 -19z"/>
<path d="M4956 4504 c-3 -9 -20 -14 -43 -14 -27 0 -46 -8 -66 -26 -16 -14 -27
-28 -25 -30 8 -7 78 17 78 28 0 6 10 8 25 4 14 -4 25 -3 24 1 -3 20 2 24 16
13 12 -10 19 -10 27 -2 7 7 20 12 29 12 9 0 19 6 22 13 3 8 -9 12 -39 13 -28
1 -45 -3 -48 -12z"/>
<path d="M5803 4493 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M4770 4480 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M6550 4481 c0 -7 -4 -9 -10 -6 -6 3 -7 -1 -4 -9 6 -16 -10 -23 -19
-8 -2 4 -2 1 0 -7 2 -8 -4 -25 -13 -39 -26 -40 0 -16 31 28 15 22 25 43 21 47
-3 3 -6 1 -6 -6z"/>
<path d="M6480 4460 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M5357 4437 c4 -6 -1 -8 -11 -4 -11 4 -29 -1 -46 -13 -15 -11 -30 -17
-33 -14 -3 3 -14 3 -25 0 -14 -5 -18 -13 -15 -26 3 -11 0 -20 -6 -20 -6 0 -11
6 -11 13 0 6 -5 4 -11 -6 -8 -14 -18 -17 -39 -12 -33 7 -110 -27 -110 -49 0
-9 -7 -12 -19 -9 -10 2 -66 -19 -130 -51 -91 -46 -111 -60 -111 -79 0 -12 -5
-29 -10 -37 -8 -12 -13 -11 -33 8 l-25 23 -48 -26 c-141 -74 -666 -295 -941
-396 -81 -29 -93 -36 -93 -57 0 -33 -52 -82 -87 -82 -27 0 -70 22 -84 43 -8
11 -1 13 -234 -46 -99 -25 -196 -49 -215 -52 -42 -9 -51 -21 -39 -52 4 -12 6
-29 3 -36 -3 -8 42 -58 108 -123 125 -120 205 -187 348 -290 l95 -69 1582 -2
1582 -3 116 85 c170 124 265 207 398 344 123 128 232 260 309 371 48 71 118
184 118 193 0 3 -28 8 -62 12 -35 3 -174 24 -310 47 l-247 41 -24 -29 c-21
-24 -33 -29 -72 -29 -40 0 -51 5 -76 33 -16 18 -29 41 -29 51 0 23 -4 24 -220
80 -85 22 -186 49 -224 60 -73 20 -84 18 -99 -23 -6 -14 -10 -16 -21 -7 -7 6
-16 8 -19 4 -4 -3 -14 0 -23 7 -10 9 -18 10 -22 4 -4 -6 -15 -13 -24 -17 -13
-5 -18 -1 -18 13 0 11 -7 20 -15 20 -8 0 -15 4 -15 8 0 4 -9 8 -21 8 -14 0
-22 -8 -26 -28 -3 -15 -9 -28 -13 -28 -5 0 -6 10 -2 22 3 13 1 19 -5 15 -6 -4
-13 3 -17 16 -5 18 -8 20 -16 7 -8 -13 -10 -12 -10 4 0 20 0 20 -15 0 -14 -18
-14 -17 -15 12 0 17 -7 38 -16 45 -15 12 -16 10 -10 -21 4 -19 10 -43 12 -52
3 -10 -3 -21 -16 -28 -22 -12 -27 -1 -8 18 9 9 9 12 0 12 -7 0 -12 9 -12 20 0
11 -5 20 -10 20 -6 0 -8 12 -5 28 4 22 4 24 -4 7 -9 -19 -12 -17 -15 14 0 8
-16 18 -34 23 -18 5 -38 17 -45 28 -6 11 -19 20 -27 21 -10 0 -8 3 5 9 16 7
14 8 -12 7 -17 -1 -29 -6 -26 -10 10 -16 -72 6 -93 25 -20 18 -28 18 -105 8
-53 -7 -107 -8 -146 -2 -41 6 -60 5 -56 -1z m756 -221 c3 -8 -3 -24 -14 -37
-15 -18 -19 -19 -19 -6 0 10 5 17 11 17 6 0 8 9 4 20 -7 22 10 28 18 6z m127
-36 c0 -5 -7 -7 -15 -4 -8 4 -15 8 -15 10 0 2 7 4 15 4 8 0 15 -4 15 -10z
m-270 -60 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4
10 -10z m34 -61 c-3 -5 -10 -7 -15 -3 -5 3 -7 10 -3 15 3 5 10 7 15 3 5 -3 7
-10 3 -15z m-1027 -486 c-9 -16 -12 -42 -9 -62 3 -26 0 -38 -13 -48 -10 -7
-16 -16 -12 -19 4 -4 2 -13 -4 -21 -9 -10 -8 -18 3 -31 8 -9 18 -26 22 -37 4
-14 -3 -11 -24 13 -25 26 -30 41 -30 80 0 50 38 146 61 154 21 8 22 3 6 -29z
m35 -75 c-7 -7 -12 -8 -12 -2 0 6 3 14 7 17 3 4 9 5 12 2 2 -3 -1 -11 -7 -17z
m111 -108 c9 -16 12 -32 7 -35 -5 -3 -11 1 -13 7 -4 10 -8 9 -16 -2 -10 -13
-12 -13 -21 0 -5 8 -10 25 -10 38 0 33 35 29 53 -8z m-65 -39 c10 -6 7 -10
-12 -13 -28 -6 -45 7 -24 15 19 8 22 8 36 -2z m-39 -51 c13 0 14 -10 2 -28 -6
-10 -12 -7 -24 12 -20 31 -23 59 -3 34 7 -10 18 -18 25 -18z m72 -100 c19 0
21 -30 2 -48 -17 -17 -16 -27 2 -46 8 -8 15 -20 15 -26 0 -6 4 -9 9 -6 5 3 11
0 14 -8 7 -19 -24 -31 -35 -14 -28 42 -51 106 -63 173 l-6 40 23 -32 c13 -18
30 -33 39 -33z"/>
<path d="M4936 4413 c-10 -10 -7 -43 4 -43 6 0 10 -7 10 -16 0 -9 5 -14 11
-12 6 2 10 8 10 13 0 6 7 17 15 26 14 15 12 18 -15 27 -16 6 -32 8 -35 5z"/>
<path d="M4780 4392 c-30 -11 -39 -17 -27 -20 25 -5 18 -46 -8 -50 -11 -2 -39
-12 -61 -22 -23 -11 -55 -22 -70 -26 -16 -3 -65 -17 -108 -30 -63 -20 -81 -22
-88 -12 -6 10 -8 9 -8 -3 0 -9 -10 -19 -22 -23 -33 -8 -38 -8 -38 8 0 9 20 19
50 27 28 7 50 16 50 21 0 4 7 8 16 8 8 0 38 10 65 22 45 19 49 23 35 36 -17
17 5 20 -550 -62 -219 -33 -230 -35 -251 -61 -17 -23 -27 -27 -48 -21 -16 4
-29 15 -32 29 -5 19 -27 30 -127 65 l-121 41 -29 -25 c-34 -28 -59 -30 -97 -8
-27 16 -30 15 -132 -42 -57 -33 -116 -65 -131 -73 -16 -8 -28 -21 -28 -30 -1
-28 -24 -46 -58 -44 -17 1 -30 -3 -27 -8 4 -5 0 -6 -8 -3 -8 3 -18 1 -22 -5
-3 -6 0 -14 8 -17 9 -3 13 -13 10 -25 -5 -17 0 -19 44 -19 56 0 252 23 400 46
87 14 105 20 118 40 31 48 102 14 75 -36 -11 -21 -49 -27 -67 -9 -7 7 -58 3
-174 -15 -183 -28 -324 -45 -444 -53 -44 -2 -93 -11 -109 -19 -16 -8 -37 -14
-48 -14 -19 0 -21 -16 -9 -60 l7 -25 8 23 c11 32 18 28 41 -23 10 -24 24 -46
30 -48 5 -2 34 -3 63 -3 28 1 52 -2 52 -6 0 -4 5 -8 11 -8 5 0 7 5 4 10 -3 6
-1 10 5 10 6 0 8 5 4 12 -4 7 -3 8 5 4 6 -4 32 -9 57 -11 44 -4 75 -15 41 -15
-9 0 -17 -4 -17 -8 0 -5 14 -7 30 -4 25 3 28 7 19 18 -6 8 -10 14 -8 15 43 8
49 7 49 -6 0 -8 4 -15 9 -15 5 0 7 9 4 20 -6 22 1 25 61 34 36 5 38 4 34 -19
-3 -15 -1 -22 7 -19 7 3 10 15 8 28 -4 20 0 24 27 28 40 6 80 -1 80 -14 0 -6
-7 -8 -15 -5 -8 4 -17 2 -21 -4 -3 -6 -12 -8 -20 -5 -7 3 -16 1 -19 -4 -4 -6
1 -10 9 -10 9 0 16 -4 16 -10 0 -5 -4 -10 -10 -10 -5 0 -10 -9 -10 -20 0 -15
-7 -20 -24 -20 -14 0 -36 -4 -50 -10 -33 -12 -46 6 -14 20 16 6 2 8 -47 3 -38
-3 -74 -9 -79 -14 -5 -5 7 -6 26 -3 41 7 62 -12 25 -21 -13 -4 -31 -6 -38 -5
-30 5 -39 -1 -39 -23 0 -13 -9 -32 -20 -42 -20 -18 -20 -17 -20 13 0 36 -13
48 -32 29 -7 -7 -26 -14 -43 -15 -16 -1 -35 -9 -41 -17 -6 -8 -21 -15 -33 -15
-12 0 -21 -6 -21 -15 0 -8 3 -15 8 -15 4 0 15 -18 25 -40 16 -37 20 -40 54
-39 32 0 35 2 16 9 -23 10 -46 43 -36 54 11 11 41 6 57 -10 13 -12 16 -13 16
-1 0 8 9 13 23 12 12 -1 20 -6 18 -11 -2 -5 -6 -15 -8 -22 -3 -8 -13 -10 -25
-6 -15 4 -18 3 -13 -6 9 -15 75 -8 230 25 176 38 258 66 272 96 28 58 65 72
132 49 48 -15 57 -13 261 66 47 18 135 51 195 75 61 23 175 71 255 106 239
106 290 136 223 127 -16 -2 -21 -1 -13 2 8 4 25 15 37 24 13 10 35 16 52 14
19 -2 31 2 35 11 3 9 18 14 38 13 44 -1 98 27 98 52 0 26 -15 33 -34 14 -16
-16 -21 -8 -10 20 3 9 14 16 23 16 20 -1 51 -24 51 -39 0 -23 20 -10 35 23 10
21 22 33 30 30 19 -8 57 33 53 57 -3 17 -6 18 -28 6 -42 -22 -89 -36 -94 -29
-3 4 9 14 25 21 29 13 40 32 17 30 -7 0 -33 -8 -58 -17z m-443 -189 c2 -6 -11
-14 -29 -18 -18 -4 -37 -10 -43 -14 -15 -10 -45 -8 -45 4 0 10 88 45 104 41 6
-1 11 -7 13 -13z m-142 -52 c3 -5 1 -13 -5 -16 -6 -4 -8 -15 -5 -26 6 -17 -3
-24 -27 -20 -5 0 -8 -3 -8 -8 0 -5 25 -9 55 -8 65 2 68 -14 5 -26 -32 -7 -45
-5 -51 5 -7 10 -9 8 -9 -6 0 -12 -5 -16 -16 -12 -8 3 -23 -1 -31 -10 -12 -11
-18 -12 -23 -4 -5 8 -9 7 -13 -5 -4 -9 -12 -15 -19 -14 -36 4 -56 -3 -61 -22
-4 -16 -11 -20 -25 -17 -11 3 -26 2 -33 -3 -21 -12 -42 10 -27 28 10 13 7 14
-21 10 -40 -7 -45 -12 -46 -40 0 -14 -7 -23 -20 -25 -11 -2 -35 -11 -53 -19
-17 -8 -41 -13 -52 -10 -10 3 -24 -1 -30 -8 -6 -7 -22 -13 -35 -14 -14 -1 -35
-3 -47 -3 -13 -1 -26 -7 -30 -12 -5 -8 -11 -7 -19 1 -6 6 -18 9 -27 6 -10 -4
-13 -2 -8 5 4 7 13 12 21 12 8 0 17 5 20 11 4 6 0 9 -10 7 -10 -2 -20 2 -22 8
-3 10 39 24 73 24 22 0 16 -17 -8 -23 -12 -4 -20 -9 -17 -12 3 -3 23 1 45 9
21 8 31 15 22 15 -25 1 -23 21 2 21 11 0 20 -7 20 -16 0 -8 4 -13 10 -9 5 3 7
12 4 20 -6 15 31 39 46 30 6 -3 10 -1 10 5 0 6 6 10 13 9 11 -2 24 2 73 21 13
5 26 4 32 -2 8 -8 13 -7 18 5 3 9 15 17 25 17 16 0 18 5 13 25 -5 21 -3 25 15
25 12 0 21 -6 21 -15 0 -8 -4 -15 -10 -15 -5 0 -10 -4 -10 -10 0 -5 18 -3 41
5 50 18 71 9 38 -16 -13 -10 -19 -19 -13 -19 6 0 14 3 18 8 4 4 13 7 19 7 7 0
11 10 9 23 -2 12 2 22 7 22 6 0 11 -7 11 -16 0 -12 7 -14 33 -9 36 8 43 12 35
21 -4 3 -16 1 -27 -6 -17 -8 -21 -8 -21 4 0 8 21 21 51 31 35 12 47 20 38 26
-7 4 -18 4 -24 0 -18 -14 -75 -30 -75 -21 0 5 15 15 33 23 96 42 93 41 102 28z
m205 -50 c-28 -16 -60 -22 -60 -12 0 10 22 18 55 20 16 0 17 -1 5 -8z m-414
-12 c8 -14 -18 -31 -30 -19 -9 9 0 30 14 30 5 0 12 -5 16 -11z m334 -8 c0 -12
-39 -21 -45 -11 -3 5 3 11 12 13 29 8 33 7 33 -2z m-440 -115 c0 -3 -4 -8 -10
-11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-370 -54 c0 -11 -87
-31 -96 -23 -3 3 14 11 38 17 55 15 58 16 58 6z m-120 -21 c0 -5 -9 -11 -20
-14 -22 -6 -28 8 -7 16 19 8 27 8 27 -2z m50 -70 c0 -5 -7 -12 -16 -15 -22 -9
-24 -8 -24 9 0 8 9 15 20 15 11 0 20 -4 20 -9z m-50 -22 c0 -5 -7 -9 -15 -9
-15 0 -20 12 -9 23 8 8 24 -1 24 -14z m-40 1 c0 -5 -5 -10 -11 -10 -5 0 -7 5
-4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z"/>
<path d="M3690 3939 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M4610 4350 c0 -5 4 -10 9 -10 6 0 13 5 16 10 3 6 -1 10 -9 10 -9 0
-16 -4 -16 -10z"/>
<path d="M4912 4324 c-7 -8 -8 -14 -3 -14 10 0 25 19 20 25 -2 1 -10 -3 -17
-11z"/>
<path d="M6057 4274 c-4 -4 -7 -14 -7 -23 0 -11 3 -12 11 -4 6 6 10 16 7 23
-2 6 -7 8 -11 4z"/>
<path d="M6130 4260 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M2932 4173 c4 -20 38 -31 38 -13 0 6 -5 8 -12 4 -9 -5 -9 -2 1 9 12
15 11 17 -9 17 -15 0 -20 -5 -18 -17z"/>
<path d="M2855 4050 c-4 -6 -21 -17 -38 -25 l-32 -15 45 6 c41 6 59 17 60 37
0 11 -28 9 -35 -3z"/>
<path d="M8055 3973 c-95 -8 -125 -14 -125 -29 0 -10 -13 -14 -45 -14 -38 0
-47 -4 -55 -22 -6 -16 -9 -18 -9 -7 -1 24 19 37 64 42 33 3 31 4 -10 3 l-50
-1 -55 -100 c-30 -56 -84 -147 -119 -204 -45 -74 -60 -105 -51 -111 8 -5 9
-10 2 -14 -6 -3 -12 -1 -14 6 -2 6 -15 -6 -28 -28 -13 -21 -29 -42 -34 -46 -8
-5 -7 -8 1 -8 6 0 21 14 33 31 12 16 24 28 27 25 3 -2 -1 -14 -9 -25 -20 -28
-9 -113 14 -117 10 -1 20 2 23 6 3 5 -4 7 -15 5 -26 -5 -26 11 0 25 15 8 20 8
20 -2 1 -8 7 -5 16 7 8 11 12 25 10 32 -3 7 1 10 9 6 10 -3 18 5 25 23 13 35
14 38 45 89 44 73 85 154 85 169 0 8 5 18 10 21 20 12 -2 -46 -48 -129 -25
-44 -57 -102 -71 -128 -47 -86 -142 -237 -157 -249 -8 -6 -14 -15 -14 -20 0
-17 -115 -168 -125 -165 -5 2 -17 0 -26 -5 -10 -5 -19 -1 -27 12 -7 11 -8 19
-2 19 5 0 10 -6 10 -12 0 -20 20 14 20 35 0 9 -5 17 -11 17 -6 0 -8 -9 -4 -20
5 -15 3 -18 -9 -14 -19 7 -21 45 -4 62 15 15 84 16 94 1 3 -6 0 -15 -7 -20 -8
-5 -9 -9 -3 -9 6 0 25 20 43 45 18 25 27 45 22 45 -22 0 -26 -2 -23 -11 1 -6
-3 -20 -9 -32 l-12 -21 -9 23 c-4 12 -6 27 -2 32 3 5 0 9 -5 9 -6 0 -11 5 -11
11 0 8 5 8 15 -1 9 -8 15 -8 15 -2 0 6 14 10 30 10 33 -1 52 16 76 70 8 17 19
32 25 32 5 0 7 5 4 11 -5 7 -14 3 -27 -10 -10 -12 -17 -25 -14 -30 3 -5 -2
-15 -10 -22 -15 -12 -16 -10 -9 21 4 19 11 37 16 38 5 2 9 11 9 20 -1 15 -3
14 -16 -3 -8 -11 -20 -19 -26 -17 -6 2 -8 -6 -5 -18 3 -11 4 -20 2 -20 -2 0
-12 -3 -22 -7 -16 -6 -16 -5 -4 10 8 11 12 30 8 50 -3 20 0 40 9 52 8 10 14
23 14 29 0 5 -14 -10 -32 -35 -88 -121 -188 -252 -249 -325 l-67 -81 150 -6
c230 -10 1164 -6 1098 4 -112 18 -261 39 -495 70 -132 18 -242 34 -244 36 -3
2 6 18 19 35 84 114 238 379 317 546 48 102 133 299 133 308 0 4 -22 3 -95 -3z
m-329 -268 c0 -14 -4 -25 -8 -25 -10 0 -10 13 -2 34 9 23 12 20 10 -9z m30 1
c0 -14 -5 -21 -9 -17 -4 4 -5 15 -1 24 9 24 12 21 10 -7z m15 -53 c-12 -20
-14 -14 -5 12 4 9 9 14 11 11 3 -2 0 -13 -6 -23z m-172 -222 c8 -14 7 -20 -4
-25 -11 -4 -14 1 -13 19 3 30 4 31 17 6z m-171 -200 c-17 -27 -34 -33 -34 -11
0 10 6 16 13 13 7 -3 16 2 19 11 4 9 8 15 11 12 2 -2 -1 -13 -9 -25z m-92 -89
c-16 -15 -25 -20 -21 -12 13 25 38 50 44 45 3 -3 -8 -18 -23 -33z m-62 -76
c-3 -8 0 -17 5 -21 16 -9 3 -25 -20 -25 -10 0 -19 -7 -19 -15 0 -17 -9 -19
-30 -5 -11 7 -12 10 -2 10 7 0 20 7 29 16 9 8 22 13 30 10 8 -4 11 -1 8 5 -4
6 -14 8 -23 4 -13 -5 -12 -2 3 15 21 24 26 25 19 6z m110 -51 c-9 -14 -19 -23
-22 -20 -5 4 26 45 35 45 2 0 -4 -11 -13 -25z m-54 -8 c-10 -9 -82 -18 -77
-10 3 5 23 10 43 11 21 2 36 1 34 -1z"/>
<path d="M2615 3940 c9 -16 17 -30 19 -30 3 0 -1 14 -7 30 -6 17 -15 30 -19
30 -5 0 -2 -13 7 -30z"/>
<path d="M2210 3711 c0 -3 19 -45 43 -91 l42 -85 104 -3 c96 -3 103 -1 96 15
-19 47 -18 49 22 45 26 -2 34 0 24 6 -11 8 -10 11 5 15 10 2 1 6 -21 7 -32 1
-36 3 -20 10 19 8 19 9 -2 9 -12 1 -24 7 -27 14 -3 6 -3 -1 0 -18 6 -32 -2
-29 -20 7 -6 12 -21 27 -32 33 -11 6 -19 15 -17 20 2 6 -5 11 -14 12 -10 0
-55 3 -100 6 -46 3 -83 2 -83 -2z m106 -69 c-6 -11 -56 -4 -56 8 0 11 43 18
54 9 4 -4 6 -12 2 -17z"/>
<path d="M2570 3651 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M2570 3600 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M2330 3476 c0 -12 111 -202 178 -304 30 -46 53 -85 50 -87 -3 -4
-297 -45 -648 -90 -63 -9 -122 -17 -130 -20 -8 -2 279 -3 637 -2 359 1 653 5
653 9 0 3 -3 8 -7 10 -5 2 -25 25 -47 51 -30 37 -41 46 -48 35 -7 -9 -8 -8 -4
5 7 21 -50 101 -65 92 -5 -4 -6 0 -4 7 3 8 -3 23 -13 33 -10 11 -48 63 -85
115 -37 52 -74 104 -82 115 -9 11 -20 27 -25 35 -5 8 -12 12 -15 8 -4 -4 7
-21 24 -39 17 -17 31 -36 31 -40 0 -21 -21 -59 -32 -59 -10 0 -10 2 0 9 23 14
-44 75 -85 77 -34 1 -34 1 -18 -23 9 -14 15 -27 12 -29 -2 -3 -14 11 -25 30
l-21 35 42 4 42 4 -47 1 c-27 1 -48 7 -51 15 -4 14 -217 18 -217 3z m310 -91
c0 -5 -5 -3 -10 5 -5 8 -10 20 -10 25 0 6 5 3 10 -5 5 -8 10 -19 10 -25z m116
-22 c-7 -7 -26 7 -26 19 0 6 6 6 15 -2 9 -7 13 -15 11 -17z m-86 -66 c0 -8 6
-17 69 -109 18 -27 29 -48 24 -48 -8 0 -116 161 -141 210 -9 18 -4 16 18 -10
16 -19 30 -39 30 -43z m21 32 c8 -15 8 -24 0 -32 -8 -8 -11 -5 -11 9 0 11 -5
25 -12 32 -9 9 -9 12 0 12 6 0 16 -9 23 -21z m125 -56 c-8 -8 -36 10 -36 23 0
8 -4 14 -10 14 -5 0 -10 8 -10 18 1 13 8 8 30 -17 16 -19 28 -36 26 -38z m-66
22 c7 -9 8 -15 2 -15 -5 0 -12 7 -16 15 -3 8 -4 15 -2 15 2 0 9 -7 16 -15z
m91 -62 c13 -16 12 -17 -3 -4 -17 13 -22 21 -14 21 2 0 10 -8 17 -17z m-43
-98 c-3 -3 -9 2 -12 12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z m126 -7 c-4 -6
-10 -5 -15 3 -14 22 -10 33 6 19 8 -7 12 -17 9 -22z m-82 -47 c8 8 13 20 10
27 -2 6 1 12 7 12 6 0 11 -4 11 -10 0 -5 11 -10 25 -10 14 0 25 -4 25 -10 0
-5 -11 -10 -25 -10 -17 0 -25 -5 -25 -17 0 -14 2 -15 9 -5 13 21 69 18 85 -4
19 -25 5 -34 -51 -34 -24 0 -43 -4 -43 -9 0 -5 8 -8 18 -6 61 12 91 13 95 1 4
-9 -10 -13 -51 -15 -48 -1 -59 2 -84 26 -15 15 -28 33 -28 40 0 7 -3 13 -7 13
-5 0 -16 15 -26 33 l-17 32 29 -34 c25 -30 30 -33 43 -20z m169 -52 c26 -33
29 -40 14 -38 -21 5 -70 79 -51 79 2 0 19 -18 37 -41z"/>
<path d="M2840 3052 c0 -12 19 -26 26 -19 2 2 -2 10 -11 17 -9 8 -15 8 -15 2z"/>
<path d="M2650 3461 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M7220 3333 c-125 -127 -249 -233 -353 -303 -36 -25 -67 -48 -67 -52
0 -5 36 -8 79 -8 l80 0 73 83 c103 116 322 399 306 396 -2 0 -55 -52 -118
-116z"/>
<path d="M2946 3385 c10 -16 21 -32 24 -35 3 -3 28 -34 55 -70 62 -83 227
-281 248 -298 12 -10 35 -12 92 -7 l76 7 -29 18 c-17 10 -38 25 -49 33 -10 9
-65 53 -123 98 -125 100 -113 89 -224 197 -48 48 -80 74 -70 57z"/>
<path d="M7507 3373 c-3 -5 -2 -15 2 -22 5 -7 11 -9 14 -4 3 5 2 15 -2 22 -5
7 -11 9 -14 4z"/>
<path d="M7450 3180 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M7395 3110 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z"/>
<path d="M8500 2870 c0 -22 2 -40 4 -40 2 0 6 18 8 40 2 22 0 40 -4 40 -5 0
-8 -18 -8 -40z"/>
<path d="M8438 2883 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8333 2850 c-35 -14 -27 -20 10 -8 17 6 34 13 36 14 8 7 -24 3 -46
-6z"/>
<path d="M6552 2778 l1 -43 4 38 4 38 67 -3 67 -3 5 -335 5 -335 3 327 c1 179
-1 333 -4 342 -5 13 -22 16 -80 16 l-74 0 2 -42z"/>
<path d="M8235 2810 c4 -6 11 -8 16 -5 14 9 11 15 -7 15 -8 0 -12 -5 -9 -10z"/>
<path d="M8493 2765 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"/>
<path d="M1884 2766 c-3 -7 -4 -42 -2 -77 l3 -64 133 4 132 3 0 -206 c0 -234
-5 -256 -64 -276 -48 -16 -102 1 -147 45 l-36 35 -52 -62 c-28 -33 -50 -66
-48 -72 2 -6 26 -28 53 -48 60 -46 126 -62 230 -56 112 7 174 41 217 123 21
38 22 55 25 353 l3 312 -221 0 c-176 0 -222 -3 -226 -14z"/>
<path d="M2685 2718 c-15 -35 -51 -117 -80 -183 -29 -66 -64 -145 -78 -175
-60 -131 -120 -269 -148 -337 -8 -23 -8 -23 86 -23 l94 0 32 80 33 80 182 0
182 0 32 -80 32 -80 100 0 c76 0 99 3 95 13 -3 6 -35 75 -70 152 -36 77 -106
230 -156 340 -50 110 -98 216 -108 235 l-18 35 -91 3 -91 3 -28 -63z m183
-278 l51 -125 -111 -3 c-61 -1 -112 -1 -114 1 -2 2 17 53 42 113 25 60 50 120
55 133 6 14 13 20 18 15 5 -5 31 -65 59 -134z"/>
<path d="M3310 2390 l0 -390 285 0 286 0 -3 78 -3 77 -192 3 -193 2 0 310 0
310 -90 0 -90 0 0 -390z"/>
<path d="M4211 2738 c-10 -24 -43 -99 -73 -168 -31 -69 -88 -199 -128 -290
-39 -91 -83 -189 -96 -219 -13 -29 -24 -55 -24 -57 0 -2 42 -4 94 -4 l94 0 32
80 32 80 182 0 181 0 34 -80 33 -80 99 0 99 0 -24 53 c-13 28 -58 129 -101
222 -42 94 -109 240 -147 325 -39 85 -75 161 -81 168 -6 8 -39 12 -99 12 l-89
0 -18 -42z m162 -265 c25 -60 50 -120 56 -135 l11 -28 -116 0 c-106 0 -116 2
-111 18 14 45 103 252 108 252 3 0 27 -48 52 -107z"/>
<path d="M4837 2773 c-4 -3 -7 -179 -7 -391 l0 -384 268 4 c264 3 268 3 323
29 72 34 119 101 119 170 0 66 -21 118 -66 159 -24 22 -48 40 -54 40 -5 0 8
18 29 39 44 44 56 84 49 161 -9 94 -85 154 -216 171 -79 10 -436 12 -445 2z
m456 -166 c38 -25 39 -86 1 -116 -24 -19 -40 -21 -155 -21 l-129 0 0 83 0 82
128 -5 c100 -4 134 -9 155 -23z m-19 -287 c53 -12 78 -39 79 -85 1 -29 -5 -43
-27 -61 -26 -23 -34 -24 -172 -24 l-144 0 0 90 0 90 113 0 c61 0 130 -5 151
-10z"/>
<path d="M5640 2390 l0 -390 90 0 90 0 0 390 0 390 -90 0 -90 0 0 -390z"/>
<path d="M8300 2745 c-7 -9 -8 -15 -2 -15 5 0 12 7 16 15 3 8 4 15 2 15 -2 0
-9 -7 -16 -15z"/>
<path d="M7490 2671 c0 -33 3 -62 8 -64 4 -3 5 21 4 54 l-4 59 71 0 70 0 4
-62 3 -63 2 68 2 67 -80 0 -80 0 0 -59z"/>
<path d="M6553 2670 c0 -30 2 -43 4 -27 2 15 2 39 0 55 -2 15 -4 2 -4 -28z"/>
<path d="M8266 2704 c-5 -14 -4 -15 9 -4 17 14 19 20 6 20 -5 0 -12 -7 -15
-16z"/>
<path d="M8480 2705 c-1 -11 -3 -32 -3 -47 -1 -16 -3 -28 -5 -28 -2 0 -17 14
-32 30 -15 17 -31 30 -35 30 -9 0 -85 -80 -85 -88 0 -4 16 10 35 31 20 20 41
37 47 37 7 0 27 -14 44 -31 l33 -32 6 25 c4 14 5 40 2 59 -2 19 -5 25 -7 14z"/>
<path d="M8235 2680 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M8275 2680 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M8205 2650 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M8175 2630 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M6552 2580 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M8080 2598 c-25 -5 -49 -15 -55 -20 -7 -8 -4 -9 8 -4 10 3 36 9 58
12 22 4 42 11 45 15 6 10 4 10 -56 -3z"/>
<path d="M6381 2591 c31 -4 71 -15 89 -25 18 -9 35 -14 37 -12 10 10 -79 40
-127 42 l-55 3 56 -8z"/>
<path d="M6995 2594 c-69 -15 -113 -30 -137 -46 l-27 -18 22 -50 c12 -27 25
-50 29 -50 4 0 -2 21 -13 46 -20 44 -18 75 2 44 7 -11 8 -9 7 10 -2 20 2 26
22 28 14 2 36 7 51 13 14 5 54 14 90 18 54 7 57 8 19 9 -25 0 -54 -2 -65 -4z"/>
<path d="M7125 2590 c3 -5 16 -10 28 -9 21 0 21 1 2 9 -28 12 -37 12 -30 0z"/>
<path d="M6255 2575 c-16 -7 -48 -30 -70 -50 -36 -34 -37 -35 -5 -11 33 25 61
40 120 64 21 9 22 11 5 11 -11 -1 -33 -7 -50 -14z"/>
<path d="M7400 2533 c0 -27 4 -53 8 -60 4 -7 8 11 7 39 0 47 2 53 25 59 23 6
23 7 -7 8 -33 1 -33 1 -33 -46z"/>
<path d="M7720 2573 c30 -3 58 -10 62 -16 5 -8 8 -6 8 6 0 15 -9 17 -62 15
l-63 -2 55 -3z"/>
<path d="M7950 2560 c-18 -12 -2 -12 25 0 13 6 15 9 5 9 -8 0 -22 -4 -30 -9z"/>
<path d="M8225 2538 c-33 -16 -67 -31 -75 -32 -8 -1 -31 -7 -50 -13 -19 -6
-63 -19 -97 -29 -35 -10 -63 -22 -63 -27 0 -5 8 -6 18 -2 9 4 58 19 107 32 81
23 225 86 225 98 0 7 3 8 -65 -27z"/>
<path d="M8208 2553 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7271 2516 c20 -20 40 -51 44 -69 4 -18 9 -27 12 -20 8 21 -28 82
-61 105 -30 21 -30 20 5 -16z"/>
<path d="M6515 2530 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M7900 2528 c0 -7 5 -20 11 -28 8 -12 9 -10 4 9 -5 15 -3 21 3 17 6
-3 13 -2 17 4 3 5 -3 10 -14 10 -12 0 -21 -6 -21 -12z"/>
<path d="M8297 2509 c-35 -26 -36 -28 -13 -25 14 1 29 6 33 9 3 4 16 -1 27
-10 21 -18 21 -18 4 3 -27 32 -21 41 8 13 24 -21 26 -22 16 -3 -21 41 -35 43
-75 13z"/>
<path d="M6993 2473 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M7068 2473 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7920 2470 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M6122 2443 c-6 -15 -13 -38 -16 -50 -3 -13 -9 -33 -12 -44 -4 -14 -2
-19 5 -15 6 4 11 17 11 29 1 12 7 40 15 62 16 45 13 60 -3 18z"/>
<path d="M6348 2463 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6438 2463 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6914 2455 c-25 -19 -15 -19 27 0 25 10 29 14 13 15 -11 0 -29 -7
-40 -15z"/>
<path d="M7648 2463 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M8220 2460 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M8391 2434 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7494 2285 c1 -106 5 -156 14 -170 l14 -20 -8 20 c-4 11 -11 88 -14
170 l-7 150 1 -150z"/>
<path d="M7641 2414 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6266 2405 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M7333 2375 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"/>
<path d="M8398 2373 c5 -59 10 -63 11 -10 1 26 -3 47 -7 47 -4 0 -6 -17 -4
-37z"/>
<path d="M6547 2320 c3 -36 7 -67 9 -69 8 -9 2 95 -6 114 -4 12 -6 -7 -3 -45z"/>
<path d="M7037 2343 c18 -2 50 -2 70 0 21 2 7 4 -32 4 -38 0 -55 -2 -38 -4z"/>
<path d="M8025 2340 c-16 -4 17 -5 75 -2 58 2 107 6 109 8 8 7 -154 2 -184 -6z"/>
<path d="M6953 2333 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M6093 2285 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z"/>
<path d="M7330 2164 c0 -85 -4 -153 -8 -150 -4 2 -14 1 -22 -5 -11 -6 -8 -9
13 -9 l27 0 0 160 c0 88 -2 160 -5 160 -3 0 -5 -70 -5 -156z"/>
<path d="M7927 2297 c-38 -32 -60 -91 -52 -144 3 -23 10 -45 15 -48 4 -3 4 12
-1 33 -10 44 8 121 24 100 6 -9 7 -8 3 5 -7 23 3 47 19 47 8 0 17 5 20 11 13
20 -1 18 -28 -4z"/>
<path d="M6241 2294 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M6849 2283 l-24 -28 28 24 c25 23 32 31 24 31 -2 0 -14 -12 -28 -27z"/>
<path d="M8150 2300 c8 -5 24 -10 34 -10 26 0 18 6 -19 14 -22 5 -26 4 -15 -4z"/>
<path d="M8113 2275 c0 -12 15 -15 69 -15 77 0 93 14 20 17 -26 1 -56 5 -68 7
-14 4 -21 1 -21 -9z"/>
<path d="M6251 2249 c-1 -14 6 -34 15 -45 8 -10 12 -13 8 -5 -4 8 -11 28 -15
45 -6 29 -7 29 -8 5z"/>
<path d="M7053 2263 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M8257 2243 c-4 -3 -7 -21 -7 -39 0 -21 -9 -42 -29 -63 -16 -17 -25
-31 -20 -31 4 0 14 7 21 15 7 9 19 22 26 30 6 7 12 20 13 27 0 7 4 4 9 -7 8
-18 9 -17 9 8 1 15 -4 27 -10 27 -6 0 -9 9 -6 20 5 21 4 24 -6 13z"/>
<path d="M6101 2225 c0 -11 4 -29 9 -40 l9 -20 0 20 c0 11 -4 29 -9 40 l-9 20
0 -20z"/>
<path d="M6535 2210 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
<path d="M7897 2193 c-3 -16 1 -39 10 -53 8 -14 11 -17 7 -5 -4 11 -7 35 -6
53 2 39 -4 42 -11 5z"/>
<path d="M6802 2178 c-2 -39 13 -83 38 -109 25 -26 93 -69 110 -69 8 1 -1 10
-20 21 -24 14 -28 19 -12 15 12 -2 22 1 22 6 0 6 -12 8 -29 5 -30 -6 -69 21
-54 38 5 4 3 5 -4 1 -15 -8 -40 45 -46 94 l-4 35 -1 -37z"/>
<path d="M7178 2180 c-2 -16 -1 -27 3 -25 11 7 18 44 9 50 -4 3 -10 -8 -12
-25z"/>
<path d="M6129 2145 c17 -34 31 -51 31 -39 0 7 -9 22 -21 35 -16 19 -18 20
-10 4z"/>
<path d="M6410 2130 l-45 -7 42 -1 c23 -1 45 3 48 8 3 6 5 9 3 8 -2 0 -23 -4
-48 -8z"/>
<path d="M7120 2118 c-35 -20 -35 -20 -5 -13 17 3 37 13 45 21 19 19 2 16 -40
-8z"/>
<path d="M7680 2132 c0 -2 6 -10 14 -18 16 -16 36 -19 36 -5 0 5 10 11 23 13
12 2 1 6 -25 9 -27 2 -48 3 -48 1z"/>
<path d="M6988 2108 c5 -5 16 -8 23 -6 8 3 3 7 -10 11 -17 4 -21 3 -13 -5z"/>
<path d="M7043 2093 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M7900 2084 c0 -14 38 -48 75 -67 17 -8 57 -18 90 -21 l60 -6 -45 15
c-25 8 -53 15 -62 15 -25 0 -96 39 -108 59 -5 9 -10 11 -10 5z"/>
<path d="M6193 2063 c20 -22 97 -63 119 -63 7 1 -9 12 -37 25 -27 14 -61 33
-75 42 l-25 17 18 -21z"/>
<path d="M6232 2064 c10 -10 20 -16 22 -13 3 3 -5 11 -17 18 -21 13 -21 12 -5
-5z"/>
<path d="M6700 2046 c0 -28 -4 -35 -22 -39 -20 -4 -19 -4 5 -6 25 -1 27 2 27
39 0 22 -2 40 -5 40 -3 0 -5 -15 -5 -34z"/>
<path d="M8403 2040 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z"/>
<path d="M6526 2061 c-9 -14 -76 -43 -131 -58 l-50 -13 50 6 c53 6 113 32 134
58 8 9 11 16 8 16 -3 0 -8 -4 -11 -9z"/>
<path d="M7540 2062 c0 -14 40 -42 60 -41 13 0 13 1 0 6 -8 3 -25 15 -37 26
-13 11 -23 15 -23 9z"/>
<path d="M7948 2063 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6561 2033 c-1 -33 -1 -33 47 -32 l47 2 -40 6 c-31 5 -41 11 -46 31
-6 23 -7 22 -8 -7z"/>
<path d="M7135 2039 c-18 -11 -24 -19 -14 -19 9 0 24 9 34 20 22 24 19 24 -20
-1z"/>
<path d="M7202 2030 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z"/>
<path d="M6270 2046 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M7804 2025 c-11 -9 -42 -14 -76 -15 -32 0 -58 -4 -58 -9 0 -12 96 -5
133 10 15 6 27 15 27 20 0 12 -3 11 -26 -6z"/>
<path d="M8195 2030 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M7075 2010 c-3 -5 1 -10 9 -10 9 0 16 5 16 10 0 6 -4 10 -9 10 -6 0
-13 -4 -16 -10z"/>
<path d="M7620 2010 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z"/>
<path d="M7015 2000 l-30 -8 33 -1 c17 0 32 4 32 9 0 6 -1 9 -2 9 -2 -1 -16
-5 -33 -9z"/>
<path d="M2300 1798 c58 -5 353 -29 655 -53 1069 -87 962 -75 1009 -111 248
-189 739 -474 1075 -624 l84 -38 111 50 c301 134 705 368 991 574 l100 72 210
16 c116 9 401 33 635 52 234 20 522 44 640 54 l215 18 -1008 1 -1008 0 -102
-63 c-174 -109 -394 -233 -593 -334 l-192 -96 -163 81 c-141 70 -276 145 -539
298 -30 17 -83 51 -117 73 l-62 42 -1023 -1 c-675 -1 -987 -5 -918 -11z m3810
-52 c0 -2 -8 -10 -17 -17 -16 -13 -17 -12 -4 4 13 16 21 21 21 13z m-50 -35
c0 -5 -7 -12 -16 -15 -14 -5 -15 -4 -4 9 14 17 20 19 20 6z m-145 -21 c-3 -5
-11 -10 -16 -10 -6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z m60 -43
c-71 -49 -127 -85 -160 -102 l-30 -16 25 21 c14 11 43 30 65 42 22 11 52 34
68 49 15 16 34 29 42 29 8 0 15 5 15 11 0 5 5 7 10 4 6 -4 -10 -21 -35 -38z
m-275 -172 c-14 -8 -29 -14 -35 -14 -5 0 1 6 15 14 14 8 30 14 35 14 6 0 -1
-6 -15 -14z m-230 -129 c0 -2 -7 -7 -16 -10 -8 -3 -12 -2 -9 4 6 10 25 14 25
6z m-170 -80 c0 -2 -7 -7 -16 -10 -8 -3 -12 -2 -9 4 6 10 25 14 25 6z"/>
<path d="M4520 1806 c0 -6 313 -178 464 -255 l139 -71 186 96 c175 91 351 189
396 220 17 12 -68 14 -583 14 -331 0 -602 -2 -602 -4z"/>
</g>
</svg>





    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
